export default {
    "A name is required": "Bir ad gerekli",
    "Age": "Yaş",
    "Total money spent, $": "Harcanan toplam para, $",
    "Clients": "Müşteriler",
    "Income": "Gelir",
    "First name": "Ad",
    "Last name": "Soyadı",
    "Position": "Pozisyon",
    "Click para seleccionar": "Seçmek için tıkla",
    "Notifications": "Bildirimler",
    "Yes": "Evet",
    "No": "Hayır",
    "City, country": "Şehir, ülke",
    "Address": "Adres",
    "Birthday": "Doğum günü",
    "Click to add tags": "Etiket eklemek için tıklayın",
    "Notes": "Notlar",
    "Reset": "Sıfırla",
    "Save": "Kaydet",
    "Top clients": "En iyi müşteriler",
    "Money spent, $": "Harcanan para, $",
    "-- Not selected --": "-- Seçilmedi --",
    "Sales manager": "Satış Müdürü",
    "Customer service": "Müşteri Hizmetleri",
    "General manager": "Genel Müdür",
    "Awarded Badges": "Kazanılan Rozetler",
    "New": "Yeni",
    "Customer": "Müşteri",
    "Supplier": "Tedarikçi",
    "Discount": "İndirim",
    "Old Buddy": "Eski Dost",
    "Avid Supporter": "Sadık Destekçi",
    "Date": "Tarih",
    "Payment": "Ödeme",
    "Purchase": "Satın Alma",
    "Sum": "Toplam",
    "Left": "Kalan",
    "Nothing on this day": "Bugün için bir şey yok",
    "Information": "Bilgi",
    "Statistics": "İstatistikler",
    "Transactions": "İşlemler",
    "Customers": "Müşteriler",
    "Charts": "Grafikler",
    "See all notifications": "Tüm bildirimleri gör",
    "Deposits News": "Para Yatırma Haberleri",
    "Dear client, we inform you about the following changes: beginning from September 24, 2018 all transactions (incoming and out...": "Sayın müşteri, sizi şu değişiklikler hakkında bilgilendiriyoruz: 24 Eylül 2018 tarihinden itibaren tüm işlemler (gelen ve giden...",
    "Search Improved": "Geliştirilmiş Arama",
    "Dear client! Following the latest updates of the SeekMeEverywhere engines, your search has become more reliable and convenient! No...": "Sayın müşteri! SeekMeEverywhere motorlarının en son güncellemelerinin ardından aramanız daha güvenilir ve kullanışlı hale geldi! Artık...",
    "Transaction Reports": "İşlem Raporları",
    "Dear client, we inform you about a change in the date of monthly transaction reports. Beginning from September 20, 2018 reports...": "Sayın müşteri, aylık işlem raporlarının tarihinde bir değişiklik olduğunu bildiririz. 20 Eylül 2018 tarihinden itibaren raporlar...",
    "Warning": "Uyarı",
    "Dear client, we know where you store your passwords.": "Sayın müşteri, şifrelerinizi nerede sakladığınızı biliyoruz.",
    "We highly recommend you to memorize them and destroy those memos of yours.": "Bunları ezberlemenizi ve notlarınızı imha etmenizi şiddetle tavsiye ederiz.",
    "Editing customers data": "Müşteri verilerini düzenleme",
    "Dear client, if you want to see the details on every customer and edit them, double-click the customer in the list on the right.": "Sayın müşteri, her bir müşterinin ayrıntılarını görmek ve düzenlemek isterseniz, sağdaki listedeki müşteriye çift tıklayın.",
    "We miss you": "Sizi özledik",
    "Dear client, it has been a while since you talked to us.": "Sayın müşteri, bizimle konuşmayalı uzun zaman oldu.",
    "We are waiting for you in the same place at the same time.": "Sizi aynı yerde, aynı saatte bekliyoruz.",
    "Have a nice day": "İyi günler",
    "Dear client, whenever you are reading this, we wish you a merry day.": "Sayın müşteri, bunu ne zaman okuyor olursanız olun, size mutlu bir gün dileriz.",
    "May the luck and success attend you.": "Şans ve başarı sizinle olsun.",
    "Localization": "Yerelleştirme",
    "Dear client, you can pick one of the six languages we provided for this demo app.": "Sayın müşteri, bu demo uygulaması için sunduğumuz altı dilden birini seçebilirsiniz.",
    "Click the icon in the top right corner.": "Sağ üst köşedeki simgeye tıklayın.",
    "We love you": "Sizi seviyoruz",
    "Dear client, we love you very much.": "Sayın müşteri, sizi çok seviyoruz.",
    "If our feelings are mutual, contact us and download Webix.": "Eğer duygularımız karşılıklıysa, bizimle iletişime geçin ve Webix'i indirin.",
    "Then we will love you eternally.": "O zaman sizi sonsuza dek seveceğiz.",
    "Persons": "Kişiler",
    "Click twice to see more goodies": "Daha fazlasını görmek için iki kez tıklayın",
    "Saved": "Kaydedildi",
    "Settings": "Ayarlar",
    "Regional settings": "Bölgesel ayarlar",
    "Language": "Dil",
    "Date format": "Tarih formatı",
    "Money format": "Para formatı",
    "Environment settings": "Ortam ayarları",
    "Theme": "Tema",
    "Light": "Açık",
    "Dark": "Koyu",
    "Max list length": "Maksimum liste uzunluğu",
    "Default settings": "Varsayılan ayarlar",
    "Open latest notifications": "En son bildirimleri aç",
    "Go to settings": "Ayarlara git",
    "All": "Tümü",
    "Payments": "Ödemeler",
    "Incoming": "Gelen",
    "Email": "E-posta",
    "Widgets": "Widget'lar",
    "Demos": "Demolar",
    "Prices": "Fiyatlar",
    "Tutorials": "Eğitimler",
    "TiraneAlbania": "Tiran, Arnavutluk",
    "Buenos AiresArgentina": "Buenos Aires, Arjantin",
    "CanberraAustralia": "Canberra, Avustralya",
    "ViennaAustria": "Viyana, Avusturya",
    "MinskBelarus": "Minsk, Beyaz Rusya",
    "BrusselsBelgium": "Brüksel, Belçika",
    "BrasiliaBrazil": "Brasilia, Brezilya",
    "OttawaCanada": "Ottawa, Kanada",
    "BeijingChina": "Pekin, Çin",
    "PragueCzech Republic": "Prag, Çek Cumhuriyeti",
    "CopenhagenDenmark": "Kopenhag, Danimarka",
    "CairoEgypt": "Kahire, Mısır",
    "HelsinkiFinland": "Helsinki, Finlandiya",
    "ParisFrance": "Paris, Fransa",
    "TbilisiGeorgia": "Tiflis, Gürcistan",
    "BerlinGermany": "Berlin, Almanya",
    "New DelhiIndia": "Yeni Delhi, Hindistan",
    "DublinIreland": "Dublin, İrlanda",
    "RomeItaly": "Roma, İtalya",
    "TokyoJapan": "Tokyo, Japonya",
    "WellingtonNew Zealand": "Wellington, Yeni Zelanda",
    "SeoulRepublic of Korea": "Seul, Kore Cumhuriyeti",
    "MadridSpain": "Madrid, İspanya",
    "StockholmSweden": "Stockholm, İsveç",
    "WashingtonUnited States": "Washington, Amerika Birleşik Devletleri",
    "Payment History": "Ödeme Geçmişi",
    "Origin of clients": "Müşterilerin Kökeni",
    "Income from various age groups": "Çeşitli yaş gruplarından gelir",
    "Clients by occupation": "Mesleğe göre müşteriler",
    "No new notifications": "Yeni bildirim yok",
    "Añadir Egreso": "Gider Ekle",
    "Añadir Ingreso": "Gelir Ekle",
    "Saldo Recargas:": "Yükleme Bakiyesi:",
    "Saldo Juego:": "Oyun Bakiyesi:",
    "Nombre": "İsim",
    "Hoy": "Bugün",
    "Ayer": "Dün",
    "Ultimos 30 días": "Son 30 gün",
    "Depósitos": "Para Yatırma",
    "Retiros": "Para Çekme",
    "Neto": "Net",
    "Desea cambiar la contraseña?": "Şifreyi değiştirmek istiyor musunuz?",
    "Salir": "Çıkış",
    "Descripción": "Açıklama",
    "Activado": "Etkin",
    "Inactivado": "Devre dışı",
    "Número de usuario": "Kullanıcı numarası",
    "Login para acceso": "Giriş için kullanıcı adı",
    "Última dirección IP": "Son IP adresi",
    "Último usuario modif": "Son değiştiren kullanıcı",
    "Tipo": "Tür",
    "Agente": "Ajan",
    "Afiliado": "Ortak",
    "Click para seleccionar": "Seçmek için tıkla",
    "Estado": "Durum",
    "Activo": "Aktif",
    "Inactivo": "Pasif",
    "Retirado": "Çekildi",
    "Idioma preferido:": "Tercih edilen dil:",
    "Nombre del usuario": "Kullanıcı adı",
    "País": "Ülke",
    "Campo Requerido": "Zorunlu Alan",
    "Moneda": "Para Birimi",
    "Fecha de creación": "Oluşturma tarihi",
    "Fecha última entrada": "Son giriş tarihi",
    "Última Fecha modif": "Son değişiklik tarihi",
    "Estado especial": "Özel durum",
    "Pinagent": "Pinagent",
    "Sí": "Evet",
    "Bloqueado para ventas": "Satışlar için engellendi",
    "Imprime recibo caja": "Kasa fişini yazdır",
    "Permite recargas": "Yüklemelere izin ver",
    "Permite activar reg": "Kayıt etkinleştirmeye izin ver",
    "Nombre del contacto": "İlgili kişinin adı",
    "Correo electrónico": "E-posta",
    "Teléfono": "Telefon",
    "Concesionario": "Bayi",
    "Subconcesionario": "Alt Bayi",
    "Provincia/Región": "İl/Bölge",
    "Ciudad": "Şehir",
    "Dirección": "Adres",
    "Barrio": "Mahalle",
    "Limite diario de recargas": "Günlük yükleme limiti",
    "Comisión recargas": "Yükleme komisyonu",
    "Apuesta mínima": "Minimum bahis",
    "Límite diario": "Günlük limit",
    "Datos Principales": "Ana Veriler",
    "Datos Agente": "Ajan Verileri",
    "Datos Configuracion": "Yapılandırma Verileri",
    "Limpiar": "Temizle",
    "Guardar": "Kaydet",
    "Completa los campos...": "Alanları doldurun...",
    "Mi Información": "Bilgilerim",
    "Contraseña Actual": "Mevcut Şifre",
    "Nueva Contraseña": "Yeni Şifre",
    "La contraseña debe contener mínimo 8 caracteres, una minúscula, una mayúscula y un número.": "Şifre en az 8 karakter, bir küçük harf, bir büyük harf ve bir rakam içermelidir.",
    "Confirmar Contraseña": "Şifreyi Onayla",
    "Contraseñas no coinciden": "Şifreler eşleşmiyor",
    "Advertencia!": "Uyarı!",
    "Contraseña cambiada satisfactoriamente": "Şifre başarıyla değiştirildi",
    "¡Exito!": "Başarılı!",
    "Nueva contraseñas no coinciden": "Yeni şifreler eşleşmiyor",
    "Verifique los campos...": "Alanları kontrol edin...",
    "Cambiar mi contraseña": "Şifremi değiştir",
    "Slug": "Kısa ad",
    "Superior": "Üst",
    "Editar Categoría": "Kategoriyi Düzenle",
    "Cancelar": "İptal",
    "Categoría Editada": "Kategori Düzenlendi",
    "Añadir Categoría": "Kategori Ekle",
    "Categoría Agregada": "Kategori Eklendi",
    "Todos": "Tümü",
    "Filtros Avanzados": "Gelişmiş Filtreler",
    "Consultar": "Sorgula",
    "Categoría": "Kategori",
    "Productos": "Ürünler",
    "Agragar Categoría Producto": "Ürün Kategorisi Ekle",
    "Categoría Producto Editada": "Ürün Kategorisi Düzenlendi",
    "Editar Categorias Productos": "Ürün Kategorilerini Düzenle",
    "Categoría Producto Agregada": "Ürün Kategorisi Eklendi",
    "Categorías": "Kategoriler",
    "Añadir Categoría Producto": "Ürün Kategorisi Ekle",
    "Nombre Encargado": "Sorumlu Adı",
    "Nit": "Vergi Numarası",
    "Es propio?": "Kendi malı mı?",
    "Añadir Tipo Producto Partner": "İş Ortağı Ürün Türü Ekle",
    "Partner Agregado": "İş Ortağı Eklendi",
    "Añadir Partner": "İş Ortağı Ekle",
    "Producto": "Ürün",
    "Proveedor": "Sağlayıcı",
    "Partner": "İş Ortağı",
    "Verificado": "Doğrulandı",
    "Filtro País": "Ülke Filtresi",
    "Mobile": "Mobil",
    "Escritorio": "Masaüstü",
    "Máximo": "Maksimum",
    "Mínimo": "Minimum",
    "Tiempo Procesamiento": "İşlem Süresi",
    "Orden": "Sıra",
    "Orden Destacado": "Öne Çıkan Sıra",
    "Filas": "Satırlar",
    "Columnas": "Sütunlar",
    "Editar Productos Partner": "İş Ortağı Ürünlerini Düzenle",
    "Producto Partner Editado": "İş Ortağı Ürünü Düzenlendi",
    "Añadir Producto Partner": "İş Ortağı Ürünü Ekle",
    "Producto Partner Agregado": "İş Ortağı Ürünü Eklendi",
    "Dispositivo": "Cihaz",
    "Editar": "Düzenle",
    "Detalle": "Detay",
    "Editar Partner": "İş Ortağını Düzenle",
    "Proveedores": "Sağlayıcılar",
    "Proveedor Partner Agregado": "İş Ortağı Sağlayıcısı Eklendi",
    "Proveedor Partner Editado": "İş Ortağı Sağlayıcısı Düzenlendi",
    "Imagen": "Resim",
    "Imagen URL": "Resim URL'si",
    "ID Externo": "Harici ID",
    "Visible": "Görünür",
    "Producto Id": "Ürün Id",
    "Editar Producto": "Ürünü Düzenle",
    "Añadir Producto": "Ürün Ekle",
    "Abreviado": "Kısaltılmış",
    "Proveedor Id": "Sağlayıcı Id",
    "Ambos": "Her ikisi de",
    "ID Usuario": "Kullanıcı ID",
    "Usuario (Correo electrónico)": "Kullanıcı (E-posta)",
    "Apellido": "Soyadı",
    "Documento": "Belge",
    "Estado de Registro": "Kayıt Durumu",
    "Rechazado": "Reddedildi",
    "Bloqueado": "Engellendi",
    "Fecha de ultimo login": "Son giriş tarihi",
    "Codigo Promocional": "Promosyon Kodu",
    "Desea activar registro?": "Kaydı etkinleştirmek istiyor musunuz?",
    "Activar registro": "Kaydı etkinleştir",
    "Ocurrio un error, comuniquese con soporte": "Bir hata oluştu, destek ile iletişime geçin",
    "No puedes activar un registro ya actualizado.": "Zaten güncellenmiş bir kaydı etkinleştiremezsiniz.",
    "Desea rechazar registro?": "Kaydı reddetmek istiyor musunuz?",
    "Rechazar registro": "Kaydı reddet",
    "Error": "Hata",
    "¡Error!": "Hata!",
    "Medio de Registro": "Kayıt Ortamı",
    "Sub Categoría": "Alt Kategori",
    "Fecha final de la autoexclusión": "Kendi kendini men etme bitiş tarihi",
    "Usuario Creación": "Oluşturan Kullanıcı",
    "Usuario Modificó": "Değiştiren Kullanıcı",
    "Juego": "Oyun",
    "Tipo saldo": "Bakiye türü",
    "Saldo recargas": "Yükleme bakiyesi",
    "Saldo retiros": "Çekim bakiyesi",
    "Detalles": "Detaylar",
    "Historial": "Geçmiş",
    "None": "Yok",
    "Cancelado": "İptal edildi",
    "Añadir Ajuste": "Düzeltme Ekle",
    "Nombre Usuario": "Kullanıcı Adı",
    "Movimiento": "Hareket",
    "Entrada": "Giriş",
    "Salida": "Çıkış",
    "Cancelación": "İptal",
    "Valor": "Değer",
    "Respuesta": "Yanıt",
    "Cerrado": "Kapalı",
    "Detalles del Ticket": "Kupon Detayları",
    "Ticket Det Id": "Kupon Detay Id",
    "Ticket ID": "Kupon ID",
    "Market": "Market",
    "Fecha": "Tarih",
    "Transacción ID": "İşlem ID",
    "Monto": "Tutar",
    "Historial de Transacciones": "İşlem Geçmişi",
    "Usuario": "Kullanıcı",
    "Premios": "Ödüller",
    "Pendiente": "Beklemede",
    "Redimido": "Kullanıldı",
    "Expirado": "Süresi Doldu",
    "Libre": "Serbest",
    "Deposito": "Para Yatırma",
    "No Deposito": "Para Yatırma Yok",
    "Partner Bono Id": "İş Ortağı Bonus Id",
    "Bono ID": "Bonus ID",
    "ID Cliente": "Müşteri ID",
    "Id Bono": "Bonus Id",
    "Nombre de Bono": "Bonus Adı",
    "Fecha Aceptación": "Kabul Tarihi",
    "Fecha Modificación": "Değişiklik Tarihi",
    "Monto Convertido": "Dönüştürülen Tutar",
    "Rollover Requerido": "Gerekli Çevrim",
    "Apostado": "Bahis Yapılan",
    "Restante": "Kalan",
    "Fecha Expiración": "Son Kullanma Tarihi",
    "Apuestas": "Bahisler",
    "Ganancias": "Kazançlar",
    "Premios Bonos": "Bonus Ödülleri",
    "Beneficio %": "Kâr %",
    "Nombre Sistema Pasarela Pago": "Ödeme Ağ Geçidi Sistemi Adı",
    "Pagada": "Ödendi",
    "Rechazada": "Reddedildi",
    "Detallado": "Detaylı",
    "Totales": "Toplamlar",
    "Resumen Financiero": "Finansal Özet",
    "Ajustar Saldo": "Bakiye Düzelt",
    "Usuario Id:": "Kullanıcı Id:",
    "Tipo Saldo:": "Bakiye Türü:",
    "Monto:": "Tutar:",
    "Transacción Id": "İşlem Id",
    "Abierto": "Açık",
    "Ganó": "Kazandı",
    "Perdió": "Kaybetti",
    "No Acción": "Eylem Yok",
    "En Espera": "Beklemede",
    "Rechazada por Regla": "Kural Nedeniyle Reddedildi",
    "Retiro Voluntario": "Gönüllü Çekilme",
    "Dirección IP": "IP Adresi",
    "Odds": "Oranlar",
    "Cambiar Contraseña": "Şifre Değiştir",
    "Código": "Kod",
    "Generar Token": "Token Oluştur",
    "Desbloquear Usuario por Clave": "Kullanıcıyı Şifreyle Aç",
    "Desbloquear": "Kilidi Aç",
    "Ocurrio un error.": "Bir hata oluştu.",
    "Cambios Realizados": "Değişiklikler Yapıldı",
    "Estado de Usuario": "Kullanıcı Durumu",
    "Estado de Contingencia": "Acil Durum",
    "Contingencia Deportivas": "Spor Acil Durum",
    "Contingencia Casino": "Casino Acil Durum",
    "Contingencia Casino en Vivo": "Canlı Casino Acil Durum",
    "Estado de Contingencia Virtuales": "Sanal Bahis Acil Durum",
    "Estado de Contingencia Poker": "Poker Acil Durum",
    "Estado de Registro del Usuario": "Kullanıcı Kayıt Durumu",
    "Verificó DNI anterior": "Önceki kimlik doğrulandı",
    "Verificó DNI posterior": "Sonraki kimlik doğrulandı",
    "Nombre sistema de pago": "Ödeme sistemi adı",
    "ID Cuenta": "Hesap ID",
    "Banco": "Banka",
    "Número Cuenta Bancaria": "Banka Hesap Numarası",
    "Código Interbancario": "Bankalararası Kod",
    "Tipo Cuenta": "Hesap Türü",
    "Ahorros": "Tasarruf",
    "Corriente": "Mevduat",
    "Cuenta Bancaria editada satisfactoriamente": "Banka hesabı başarıyla düzenlendi",
    "Formas de Pago": "Ödeme Yöntemleri",
    "Efectivo": "Nakit",
    "Cuenta Bancaria": "Banka Hesabı",
    "Giro Bancario": "Banka Havalesi",
    "Punto de Venta": "Satış Noktası",
    "Filtros": "Filtreler",
    "Seguridad Cambios": "Değişiklik Güvenliği",
    "Exportar": "Dışa Aktar",
    "Cuentas Bancarias": "Banka Hesapları",
    "Total Depósitos": "Toplam Para Yatırma",
    "Total Apuestas Deportivas": "Toplam Spor Bahisleri",
    "Total Ganancias Deportivas": "Toplam Spor Kazançları",
    "Total Apuestas Casino": "Toplam Casino Bahisleri",
    "Ganancias Totales Casino": "Toplam Casino Kazançları",
    "Total Retiros": "Toplam Para Çekme",
    "Total Ajustes Entrada": "Toplam Giriş Düzeltmeleri",
    "Total Ajustes Salida": "Toplam Çıkış Düzeltmeleri",
    "Detalles Avanzados": "Gelişmiş Detaylar",
    "Guardado": "Kaydedildi",
    "Error!": "Hata!",
    "Añadir Cuenta": "Hesap Ekle",
    "Cuenta": "Hesap",
    "Editar Cuenta": "Hesabı Düzenle",
    "Cuenta Actualizado": "Hesap Güncellendi",
    "Cuenta Agregado": "Hesap Eklendi",
    "Encargado": "Sorumlu",
    "Añadir Área": "Alan Ekle",
    "Editar Área": "Alanı Düzenle",
    "Área Actualizado": "Alan Güncellendi",
    "Área Agregado": "Alan Eklendi",
    "Datos no han podido ser cargados": "Veriler yüklenemedi",
    "Hora Inicio": "Başlangıç Saati",
    "Hora Cierre": "Bitiş Saati",
    "ID Plan de Cuentas": "Hesap Planı ID",
    "Referencia": "Referans",
    "Añadir Concepto": "Kavram Ekle",
    "Plan de cuenta": "Hesap planı",
    "Cuenta Id": "Hesap Id",
    "Editar Concepto": "Kavramı Düzenle",
    "Concepto Actualizado": "Kavram Güncellendi",
    "Concepto Agregado": "Kavram Eklendi",
    "Tipo de Centro": "Merkez Türü",
    "Añadir Centro": "Merkez Ekle",
    "Editar Centro": "Merkezi Düzenle",
    "Centro Actualizado": "Merkez Güncellendi",
    "Centro Agregado": "Merkez Eklendi",
    "Área": "Alan",
    "Cargo": "Pozisyon",
    "Añadir Empleado": "Çalışan Ekle",
    "Tipo Documento": "Belge Türü",
    "Cedula": "Kimlik Kartı",
    "Cedula de extrangería": "Yabancı Kimlik Kartı",
    "Pasaporte": "Pasaport",
    "Salario": "Maaş",
    "Empleado Agregado": "Çalışan Eklendi",
    "Editar Empleado": "Çalışanı Düzenle",
    "Empleado Actualizado": "Çalışan Güncellendi",
    "Consecutivo": "Ardışık",
    "Tarjeta de crédito": "Kredi kartı",
    "Tipo de Egreso": "Gider Türü",
    "Documento ID": "Belge ID",
    "Centro de Costos": "Maliyet Merkezi",
    "Concepto": "Kavram",
    "Creador": "Oluşturan",
    "Impuesto": "Vergi",
    "Retracción": "Geri Çekme",
    "Añadir Gasto": "Gider Ekle",
    "Es punto de venta?": "Satış noktası mı?",
    "Gasto Agregado": "Gider Eklendi",
    "Factura": "Fatura",
    "Editar Gasto": "Gideri Düzenle",
    "Gasto Actualizado": "Gider Güncellendi",
    "Tipo de Ingreso": "Gelir Türü",
    "Soporte": "Destek",
    "Ingreso Agregado": "Gelir Eklendi",
    "Ingreso Actualizado": "Gelir Güncellendi",
    "Añadir Cargo": "Pozisyon Ekle",
    "Tipo Cargo": "Pozisyon Türü",
    "Cargo Agregado": "Pozisyon Eklendi",
    "Productos Internos?": "Dahili Ürünler?",
    "Añadir Producto Tercero": "Üçüncü Taraf Ürünü Ekle",
    "Cuenta Contable Ingreso": "Gelir Muhasebe Hesabı",
    "Cuenta Contable Egreso": "Gider Muhasebe Hesabı",
    "Producto Interno?": "Dahili Ürün?",
    "Tipo Interno": "Dahili Tür",
    "Plan cuentas Apuestas Tickets Tiendas": "Mağaza Bahis Kuponları Hesap Planı",
    "Plan cuentas Premios Tickets Tiendas": "Mağaza Ödül Kuponları Hesap Planı",
    "Plan cuentas Pagos notas de retiro": "Para Çekme Notları Ödemeleri Hesap Planı",
    "Plan de cuentas Recargas": "Yüklemeler Hesap Planı",
    "Editar Producto Tercero": "Üçüncü Taraf Ürününü Düzenle",
    "Producto Tercero Agregado": "Üçüncü Taraf Ürünü Eklendi",
    "Producto Tercero Actualizado": "Üçüncü Taraf Ürünü Güncellendi",
    "Producto Terceros": "Üçüncü Taraf Ürünleri",
    "Añadir": "Ekle",
    "Cuenta Contable": "Muhasebe Hesabı",
    "Agregada": "Eklendi",
    "RUC - NIT": "Vergi Kimlik Numarası",
    "Añadir Proveedor": "Tedarikçi Ekle",
    "Proveedor Agregado": "Tedarikçi Eklendi",
    "Proveedor Actualizado": "Tedarikçi Güncellendi",
    "Valor Entradas": "Giriş Değeri",
    "Valor Salidas": "Çıkış Değeri",
    "Nivel": "Seviye",
    "Con Cajero": "Kasiyerli",
    "Centro": "Merkez",
    "Añadir Tipo": "Tür Ekle",
    "Editar Tipo": "Türü Düzenle",
    "Tipo Actualizado": "Tür Güncellendi",
    "Tipo Agregado": "Tür Eklendi",
    "Plan de Cuentas": "Hesap Planı",
    "Areas": "Alanlar",
    "Empleados": "Çalışanlar",
    "Reporte de cierre de día": "Gün Sonu Raporu",
    "Conceptos": "Kavramlar",
    "Egresos": "Giderler",
    "Reporte de Gastos": "Gider Raporu",
    "Ingresos": "Gelirler",
    "Otros Ingresos": "Diğer Gelirler",
    "Cargos": "Pozisyonlar",
    "Producto Tercero": "Üçüncü Taraf Ürünü",
    "Producto Tercero Punto de Venta": "Satış Noktası Üçüncü Taraf Ürünü",
    "Productos Terceros": "Üçüncü Taraf Ürünleri",
    "Productos Terceros Punto de Venta": "Satış Noktası Üçüncü Taraf Ürünleri",
    "Reporte de Cuadre de día": "Günlük Mutabakat Raporu",
    "Reporte de Cuadre de día 2": "Günlük Mutabakat Raporu 2",
    "Tipos": "Türler",
    "Añadir Tipos": "Tür Ekle",
    "Afiliador": "Ortaklık Sağlayıcı",
    "No Procesado": "İşlenmedi",
    "Añadir Agente": "Ajan Ekle",
    "Estado Validación": "Doğrulama Durumu",
    "Región": "Bölge",
    "Departamento": "Departman",
    "Modificado": "Değiştirildi",
    "¿ Qué desea realizar ?": "Ne yapmak istersiniz?",
    "Traslado a Saldo Recargas": "Yükleme Bakiyesine Aktar",
    "Traslado a Saldo Juego": "Oyun Bakiyesine Aktar",
    "Transferir a saldo Recargas a": "Yükleme bakiyesine transfer et",
    "Transferir": "Transfer",
    "No Se ha realizado la transferencia. Comunicarse con soporte.": "Transfer gerçekleştirilemedi. Destek ile iletişime geçin.",
    "Se ha realizado la transferencia satisfactoriamente.": "Transfer başarıyla gerçekleştirildi.",
    "Transferir a Saldo Juego a": "Oyun Bakiyesine Transfer Et",
    "Saldo Juego Actual": "Mevcut Oyun Bakiyesi",
    "Saldo Recargas Actual": "Mevcut Yükleme Bakiyesi",
    "Saldo de Recargas": "Yükleme Bakiyesi",
    "Saldo de Juego": "Oyun Bakiyesi",
    "Confirmar Valor": "Değeri Onayla",
    "Recargar": "Yükle",
    "Los montos no coinciden": "Tutarlar eşleşmiyor",
    "Cupos Asignados": "Atanan Kotalar",
    "Historial cambios de cupo": "Kota değişiklik geçmişi",
    "Tipo Cupo": "Kota Türü",
    "Recargas": "Yüklemeler",
    "Tipo Transacción": "İşlem Türü",
    "Asignado Por": "Atayan",
    "Comisión Nivel 1": "Komisyon Seviye 1",
    "Comisión Nivel 2": "Komisyon Seviye 2",
    "Comisión Nivel 3": "Komisyon Seviye 3",
    "Comisión Nivel 4": "Komisyon Seviye 4",
    "Comisión Punto": "Nokta Komisyonu",
    "Editar Comisión": "Komisyonu Düzenle",
    "Valores Editados": "Düzenlenen Değerler",
    "Mensual": "Aylık",
    "Diario": "Günlük",
    "Valor Base": "Temel Değer",
    "Comision": "Komisyon",
    "Valor Pagado": "Ödenen Değer",
    "External ID": "Harici ID",
    "Pregunta": "Soru",
    "Saldo Afiliados": "Ortak Bakiyesi",
    "Desea pagar comisión en efectivo?": "Komisyonu nakit ödemek ister misiniz?",
    "Comisión Pagada": "Komisyon Ödendi",
    "Desea abonar comisión a saldo recargas?": "Komisyonu yükleme bakiyesine eklemek ister misiniz?",
    "Desea abonar comisión a saldo juego?": "Komisyonu oyun bakiyesine eklemek ister misiniz?",
    "Desea abonar comisión a saldo afiliados?": "Komisyonu ortak bakiyesine eklemek ister misiniz?",
    "Desea Aprobar Comisión": "Komisyonu Onaylamak İstiyor musunuz?",
    "Aprobar Comisión": "Komisyonu Onayla",
    "Comisión Aprobado": "Komisyon Onaylandı",
    "Restricción IP": "IP Kısıtlaması",
    "Token Google": "Google Token",
    "Token Local": "Yerel Token",
    "No tienes un QR Configurado.": "Yapılandırılmış bir QR kodunuz yok.",
    "UserModifId": "DeğiştirenKullanıcıId",
    "Comisiones": "Komisyonlar",
    "Apuestas Totales Liquidadas": "Toplam Sonuçlanan Bahisler",
    "Deporte Profitness": "Spor Profitness",
    "Casino Profitness": "Casino Profitness",
    "Reporte de Retiros": "Para Çekme Raporu",
    "Tipo de Apuesta": "Bahis Türü",
    "Apuestas Creadas": "Oluşturulan Bahisler",
    "Apuestas Cerradas": "Kapanan Bahisler",
    "Apuestas Pagadas": "Ödenen Bahisler",
    "Cantidad Tickets": "Kupon Miktarı",
    "Stake": "Bahis Tutarı",
    "Stake Promedio": "Ortalama Bahis Tutarı",
    "Payout": "Ödeme",
    "Bonos": "Bonuslar",
    "Bonos1": "Bonuslar1",
    "Fecha Creación": "Oluşturma Tarihi",
    "Pendientes": "Beklemede",
    "Acción": "Eylem",
    "Bono Deposito": "Para Yatırma Bonusu",
    "Bono No Deposito": "Para Yatırma Bonusu Yok",
    "Freebet": "Bedava Bahis",
    "Presupuesto": "Bütçe",
    "Aprobado": "Onaylandı",
    "Responder Solicitud": "Talebi Yanıtla",
    "Respuesta Generada": "Yanıt Oluşturuldu",
    "Envie una Respuesta": "Bir Yanıt Gönder",
    "Aprobar Solicitud": "Talebi Onayla",
    "Rechazar Solicitud": "Talebi Reddet",
    "Requisitos": "Gereksinimler",
    "Historial de requisitos enviados": "Gönderilen gereksinimlerin geçmişi",
    "Requisito": "Gereksinim",
    "Añadir Requisito": "Gereksinim Ekle",
    "Tipo Usuario": "Kullanıcı Türü",
    "Editar Requisito": "Gereksinimi Düzenle",
    "Nombre:": "Ad:",
    "Tipo Usuario:": "Kullanıcı Türü:",
    "Requisito Editado": "Gereksinim Düzenlendi",
    "Requisito Agregado": "Gereksinim Eklendi",
    "Estadisticas Marketing": "Pazarlama İstatistikleri",
    "Marketing Vs Registros": "Pazarlama vs Kayıtlar",
    "Top Usuarios": "En İyi Kullanıcılar",
    "Clave": "Şifre",
    "Datos Configuración": "Yapılandırma Verileri",
    "Reporte de Bonos": "Bonus Raporu",
    "Reporte de Casino": "Casino Raporu",
    "Reporte de Comisiones": "Komisyon Raporu",
    "Reporte de Comisiones Detallado": "Detaylı Komisyon Raporu",
    "QR Google": "Google QR",
    "Reporte de Depósitos": "Para Yatırma Raporu",
    "Flujo de Caja": "Nakit Akışı",
    "Reporte de Flujo de Caja": "Nakit Akışı Raporu",
    "Flujo de caja hijos": "Alt Nakit Akışı",
    "Reporte de Flujo de Caja Hijos": "Alt Nakit Akışı Raporu",
    "Reporte de Apuestas": "Bahis Raporu",
    "Flujo Caja Hijos": "Alt Nakit Akışı",
    "Usuarios Afiliados": "Ortak Kullanıcılar",
    "Marketing": "Pazarlama",
    "Informe": "Rapor",
    "Códigos Promocionales": "Promosyon Kodları",
    "Solicitudes de Agentes": "Ajan Talepleri",
    "Ultimos 3 días": "Son 3 gün",
    "Ultimos 7 días": "Son 7 gün",
    "Añadir Punto": "Nokta Ekle",
    "Login": "Giriş",
    "Apuesta Total": "Toplam Bahis",
    "Latitud": "Enlem",
    "Longitud": "Boylam",
    "Punto de venta Agregado": "Satış Noktası Eklendi",
    "Editar Punto": "Noktayı Düzenle",
    "Competencia": "Rekabet",
    "Punto de venta Actualizado": "Satış Noktası Güncellendi",
    "Publicidad Punto": "Nokta Reklamı",
    "Añadir Publicidad": "Reklam Ekle",
    "Añadir Publicidad Cajero": "Kasiyer Reklamı Ekle",
    "Cajeros": "Kasiyerler",
    "Añadir Cajero": "Kasiyer Ekle",
    "Ruta": "Rota",
    "Publicidad Añadida": "Reklam Eklendi",
    "Editar Publicidad": "Reklamı Düzenle",
    "Publicidad Actualizada": "Reklam Güncellendi",
    "Publicidad Cajero Añadida": "Kasiyer Reklamı Eklendi",
    "Editar Publicidad Cajero": "Kasiyer Reklamını Düzenle",
    "Abrir Publicidad": "Reklamı Aç",
    "Computador ID": "Bilgisayar ID",
    "Min Apuesta": "Min Bahis",
    "Max Apuesta Live": "Maks Canlı Bahis",
    "Max Apuesta PreMatch": "Maks Maç Öncesi Bahis",
    "Cajero Agregado": "Kasiyer Eklendi",
    "Comisión Usuario": "Kullanıcı Komisyonu",
    "por Abuelo": "Büyükbaba tarafından",
    "por Padre": "Baba tarafından",
    "por Hijo": "Oğul tarafından",
    "por Nieto": "Torun tarafından",
    "Total": "Toplam",
    "Total:": "Toplam:",
    "Usuario REF": "Referans Kullanıcı",
    "Fecha de Creación": "Oluşturma Tarihi",
    "Pregunta": "Soru",
    "Seleccione el tipo de saldo": "Bakiye türünü seçin",
    "Saldo Recarga": "Yükleme Bakiyesi",
    "Ganancias sujetas a impuestos": "Vergiye tabi kazançlar",
    "Valor Apostado": "Bahis Tutarı",
    "Valor Premio": "Ödül Tutarı",
    "Ganancia": "Kazanç",
    "La contraseña debe contener mínimo 6 caracteres y un número, un carácter no se puede repetir más de 3 veces consecutivamente": "Şifre en az 6 karakter ve bir rakam içermeli, bir karakter art arda 3 defadan fazla tekrar edemez",
    "Fecha ultima detección": "Son tespit tarihi",
    "Plataforma": "Platform",
    "Nombre Archivo": "Dosya Adı",
    "Hash Original": "Orijinal Hash",
    "Hash Detectado": "Tespit Edilen Hash",
    "Fecha modificación": "Değişiklik tarihi",
    "Reporte de Hash": "Hash Raporu",
    "Tecnología": "Teknoloji",
    "Financiero": "Finansal",
    "Filtrar Tabla": "Tabloyu Filtrele",
    "Dirigido al Departamento": "Departmana Yönlendirildi",
    "Título de la petición": "Talep Başlığı",
    "Título": "Başlık",
    "Generar Petición": "Talep Oluştur",
    "Generar": "Oluştur",
    "Añadir Respuesta": "Yanıt Ekle",
    "Respuestas de la petición": "Talep Yanıtları",
    "La petición debe estar activa": "Talep aktif olmalı",
    "Usuario Creo": "Oluşturan Kullanıcı",
    "Desea cerrar la petición?": "Talebi kapatmak istiyor musunuz?",
    "Cerrar Peticíon": "Talebi Kapat",
    "Estado de petición actualizada": "Talep durumu güncellendi",
    "Desea Activar la petición?": "Talebi etkinleştirmek istiyor musunuz?",
    "Activar Peticíon": "Talebi Etkinleştir",
    "Responder Petición": "Talebi Yanıtla",
    "Peticiones": "Talepler",
    "Mensaje Id": "Mesaj Id",
    "Casino": "Casino",
    "Live Casino": "Canlı Casino",
    "Añadir Mensaje": "Mesaj Ekle",
    "Editar Mensaje": "Mesajı Düzenle",
    "Mensaje": "Mesaj",
    "Asunto": "Konu",
    "Emisor": "Gönderen",
    "Receptor": "Alıcı",
    "Leido": "Okundu",
    "Mensajes": "Mesajlar",
    "Tipo de Producto": "Ürün Türü",
    "Fecha Inicio": "Başlangıç Tarihi",
    "Fecha Fin": "Bitiş Tarihi",
    "Añadir Liga": "Lig Ekle",
    "Resultados": "Sonuçlar",
    "Fecha del ultimo logueo": "Son giriş tarihi",
    "Reporte de Apuestas Deportivas": "Spor Bahisleri Raporu",
    "Usuarios": "Kullanıcılar",
    "Tabla de Resultados": "Sonuçlar Tablosu",
    "Nro": "No",
    "Puntuación": "Puan",
    "Saldo Actual de usuarios por Edades": "Yaşlara Göre Kullanıcıların Mevcut Bakiyesi",
    "Deportivo": "Spor",
    "Si": "Evet",
    "Liga Agregada Correctamente": "Lig Başarıyla Eklendi",
    "La Fecha de inicio debe ser menor a la fecha fin.": "Başlangıç tarihi bitiş tarihinden önce olmalıdır.",
    "Añadir Liga:": "Lig Ekle:",
    "Segundo Nombre": "İkinci Ad",
    "Notificaciones": "Bildirimler",
    "Lista de Ligas": "Ligler Listesi",
    "Información": "Bilgi",
    "Reportes": "Raporlar",
    "Configuración": "Yapılandırma",
    "Reporte de Usuarios": "Kullanıcı Raporu",
    "Publicidad Máquina": "Makine Reklamı",
    "Id Nota de Retiro": "Para Çekme Notu Id",
    "Valor a pagar": "Ödenecek tutar",
    "Premio Proyectado": "Tahmini Ödül",
    "Ganador": "Kazanan",
    "Pagar Nota Retiro": "Para Çekme Notunu Öde",
    "No. Ticket": "Kupon No.",
    "Clave Ticket": "Kupon Şifresi",
    "Pagar Premio": "Ödülü Öde",
    "Encendida": "Açık",
    "Apagada": "Kapalı",
    "Usuario Actualizó": "Güncelleyen Kullanıcı",
    "Reporte de Logs": "Log Raporu",
    "Reporte de Actualizaciones": "Güncelleme Raporu",
    "Actualizar Versión": "Sürümü Güncelle",
    "Vinculo": "Bağlantı",
    "Actualizar": "Güncelle",
    "Actualizar Ambos": "Her İkisini de Güncelle",
    "Enviar Comando a": "Komut Gönder",
    "Enviar": "Gönder",
    "Tipo Establecimiento": "Kuruluş Türü",
    "Versión": "Sürüm",
    "Documento 1": "Belge 1",
    "Documento 2": "Belge 2",
    "Añadir Traducción": "Çeviri Ekle",
    "Traducción Agregada": "Çeviri Eklendi",
    "Editar Traducción": "Çeviriyi Düzenle",
    "Traducción Editada": "Çeviri Düzenlendi",
    "Obtener URL": "URL Al",
    "Subir Imagen": "Resim Yükle",
    "Primer nombre": "Ad",
    "CashDesk Name": "Kasa Adı",
    "Hora": "Saat",
    "Usuario que lo creo": "Oluşturan kullanıcı",
    "Tipo:": "Tür:",
    "Descripción:": "Açıklama:",
    "Valor:": "Değer:",
    "Ingreso por tarjeta de crédito añadido satisfactoriamente": "Kredi kartı geliri başarıyla eklendi",
    "Seleccione tipo de factura": "Fatura türünü seçin",
    "POS": "POS",
    "CARTA": "MEKTUP",
    "Nro. Documento": "Belge No.",
    "Proveedor Tercero": "Üçüncü Taraf Sağlayıcı",
    "Concepto:": "Kavram:",
    "Nro. Documento:": "Belge No:",
    "Proveedores Terceros": "Üçüncü Taraf Sağlayıcılar",
    "Error, comuniquese con soporte.": "Hata, destek ile iletişime geçin. ",
    "Egreso añadido satisfactoriamente": "Gider başarıyla eklendi",
    "Proveedor Tercero:": "Üçüncü Taraf Sağlayıcı:",
    "Ingreso añadido satisfactoriamente": "Gelir başarıyla eklendi",
    "Dinero Inicial:": "Başlangıç Parası:",
    "Total Ingresos:": "Toplam Gelirler:",
    "Total Egresos:": "Toplam Giderler:",
    "Ingresos Tarjeta Credito:": "Kredi Kartı Gelirleri:",
    "Verifique que todos los datos sean validos": "Tüm verilerin geçerli olduğunu doğrulayın",
    "Forma Pago 1": "Ödeme Yöntemi 1",
    "Pago Bono / T.C.": "Bonus / K.K. Ödemesi",
    "Valor Entradas Efectivo": "Nakit Giriş Değeri",
    "Valor Entradas Bono / T.C.": "Bonus / K.K. Giriş Değeri",
    "Valor Entradas Traslados": "Transfer Giriş Değeri",
    "Valor Entradas Recargas": "Yükleme Giriş Değeri",
    "Valor Salidas Efectivo": "Nakit Çıkış Değeri",
    "Valor Salidas Traslados": "Transfer Çıkış Değeri",
    "Valor Salidas Notas de Retiro": "Para Çekme Notları Çıkış Değeri",
    "V.Entradas Efectivo": "Nakit Giriş D.",
    "V.Entradas Efectivo Neto": "Net Nakit Giriş D.",
    "V.Entradas Bono/T.C": "Bonus/K.K Giriş D.",
    "V.Entradas Traslados": "Transfer Giriş D.",
    "V.Entradas Recargas": "Yükleme Giriş D.",
    "V.Salidas Efectivo": "Nakit Çıkış D.",
    "V.Salidas Efectivo Neto": "Net Nakit Çıkış D.",
    "V.Salidas Traslados": "Transfer Çıkış D.",
    "V.Salidas N.Retiro": "Ç.Notu Çıkış D.",
    "Saldo": "Bakiye",
    "Pagada?": "Ödendi mi?",
    "Numero del cliente:": "Müşteri numarası:",
    "Cedula del cliente:": "Müşteri kimliği:",
    "Email del cliente:": "Müşteri e-postası:",
    "Campo No Valido": "Geçersiz Alan",
    "Filtre Mínimo por un campo": "En az bir alana göre filtrele",
    "Nro. de Cliente:": "Müşteri No:",
    "Nombre del Cliente:": "Müşteri Adı:",
    "País:": "Ülke:",
    "Moneda:": "Para Birimi:",
    "Valor a Recargar:": "Yüklenecek Tutar:",
    "Desea Realizar la Recarga?": "Yüklemeyi Gerçekleştirmek İstiyor musunuz?",
    "Ocurrio un error...": "Bir hata oluştu...",
    "Recarga Completada Satisfactoriamente": "Yükleme Başarıyla Tamamlandı",
    "Añadir Competidor": "Rakip Ekle",
    "Competidores": "Rakipler",
    "Competidor Agregado": "Rakip Eklendi",
    "Editar Competidor": "Rakibi Düzenle",
    "Competidor Editado": "Rakip Düzenlendi",
    "Fecha de creación:": "Oluşturma tarihi:",
    "Nombre de Usuario:": "Kullanıcı Adı:",
    "Valor de la nota:": "Not değeri:",
    "Eliminar Nota": "Notu Sil",
    "ID Nota de Retiro:": "Para Çekme Notu ID:",
    "Observaciones:": "Gözlemler:",
    "Nro Nota Retiro:": "Para Çekme Notu No:",
    "Nro Usuario:": "Kullanıcı No:",
    "Fecha Eliminación": "Silme Tarihi",
    "Nombre del Usuario:": "Kullanıcı Adı:",
    "Usuario que la Eliminó:": "Silen Kullanıcı:",
    "Fecha Nota": "Not Tarihi",
    "Nro Nota Retiro": "Para Çekme Notu No",
    "Valor Nota": "Not Değeri",
    "Observaciones": "Gözlemler",
    "Historial de gestiones": "Yönetim geçmişi",
    "Fecha/hora": "Tarih/saat",
    "Texto": "Metin",
    "Nota Generada": "Not Oluşturuldu",
    "Nombres:": "Adlar:",
    "Apellidos:": "Soyadlar:",
    "Teléfono:": "Telefon:",
    "Skype:": "Skype:",
    "Dirección:": "Adres:",
    "Email:": "E-posta:",
    "Empresa:": "Şirket:",
    "Empresa": "Şirket",
    "Provincia": "İl",
    "Observacion": "Gözlem",
    "Fecha/Hora Ultima Modif": "Son Değişiklik Tarihi/Saati",
    "Usuario Ultima Modif": "Son Değiştiren Kullanıcı",
    "Desea Terminar Gestión?": "Yönetimi Bitirmek İstiyor musunuz?",
    "Terminar Gestión": "Yönetimi Bitir",
    "Gestión Terminada satisfactoriamente.": "Yönetim başarıyla tamamlandı.",
    "Cedula de Ciudadania": "Vatandaşlık Kimliği",
    "Cedula de Extranjeria": "Yabancı Kimliği",
    "Primer Nombre:": "Ad:",
    "Nro Documento:": "Belge No:",
    "Segundo Nombre:": "İkinci Ad",
    "Segundo Nombre": "İkinci Ad",
    "Primer Apellido:": "Soyadı:",
    "Primer Apellido": "Soyadı",
    "Segundo Apellido:": "İkinci Soyadı:",
    "Segundo Apellido": "İkinci Soyadı",
    "Nro Cheque:": "Çek No:",
    "Nro Cheque": "Çek No",
    "Origen": "Kaynak",
    "Nota Retiro": "Para Çekme Notu",
    "Ticket": "Kupon",
    "Cliente:": "Müşteri:",
    "Cliente": "Müşteri",
    "Documento Referente:": "Referans Belgesi:",
    "Documento Referente": "Referans Belgesi",
    "Doc. Cliente:": "Müşteri Belgesi:",
    "Doc. Cliente": "Müşteri Belgesi",
    "Nro. Recarga:": "Yükleme No:",
    "Nro. Recarga": "Yükleme No",
    "Nro. Cliente:": "Müşteri No:",
    "Nro. Cliente": "Müşteri No",
    "Nombre Cliente:": "Müşteri Adı:",
    "Nombre Cliente": "Müşteri Adı",
    "Usuario Solicita": "Talep Eden Kullanıcı",
    "Campo": "Alan",
    "Antiguo": "Eski",
    "Nuevo": "Yeni",
    "Aprobadas": "Onaylananlar",
    "Rechazadas": "Reddedilenler",
    "Desea Rechazar el log?": "Logu reddetmek istiyor musunuz?",
    "Rechazar log": "Logu reddet",
    "Estado de log actualizado": "Log durumu güncellendi",
    "Desea Aprobar el log?": "Logu onaylamak istiyor musunuz?",
    "UserName": "KullanıcıAdı",
    "Listo": "Hazır",
    "Aprobada": "Onaylandı",
    "Tipo de usuario": "Kullanıcı türü",
    "Administrador General": "Genel Yönetici",
    "Administrador Secundario": "İkincil Yönetici",
    "Operador": "Operatör",
    "System Administrator": "Sistem Yöneticisi",
    "Consultas": "Sorgular",
    "ADMIN AFILIADOS": "ORTAK YöneticİSİ",
    "CUSTOM": "öZEL",
    "Usuario de País": "Ülke Kullanıcısı",
    "Categoría cliente": "Müşteri kategorisi",
    "Añadir Usuario": "Kullanıcı Ekle",
    "Numero de Documento": "Belge Numarası",
    "Género": "Cinsiyet",
    "Cumpleaños": "Doğum Günü",
    "Está bloqueado?": "Engelli mi?",
    "País Residencia": "İkamet Ülkesi",
    "Provincia/Región Residencia": "İkamet İli/Bölgesi",
    "Ciudad Residencia": "İkamet Şehri",
    "Código Zip": "Posta Kodu",
    "Celular": "Cep Telefonu",
    "Fecha de registro": "Kayıt tarihi",
    "Perfil": "Profil",
    "Página": "Sayfa",
    "DíasCaducidadClave": "ŞifreGeçerlilikSüresi",
    "Menus no permitidos": "İzin verilmeyen menüler",
    "Menus Permitidos": "İzin verilen menüler",
    "ADMIN": "Yöneticİ",
    "ADMIN2": "Yöneticİ2",
    "ADMIN AGGREGATOR": "TOPLAYICI YöneticİSİ",
    "CAJERO": "KASİYER",
    "CONCESIONARIO": "BAYİ",
    "CONCESIONARIO2": "BAYİ2",
    "OPERADOR": "OPERATöR",
    "PUNTOVENTA": "SATIŞNOKTASI",
    "CONSULTAS": "SORGULAR",
    "ADMINAFILIADOS": "ORTAKYöneticİSİ",
    "Debe de seleccionar un usuario.": "Bir kullanıcı seçmelisiniz.",
    "Menu": "Menü",
    "Submenu": "Alt Menü",
    "Adicionar": "Ekle",
    "Cedula Nacional": "Ulusal Kimlik",
    "Cedula Extranjera": "Yabancı Kimlik",
    "Trabajador": "Çalışan",
    "Familiar Trabajador": "Çalışan Ailesi",
    "Añadir Usuario a Bloquear": "Engellenecek Kullanıcı Ekle",
    "Usuario Asociado": "İlişkili Kullanıcı",
    "Regional": "Bölgesel",
    "Tipo Punto": "Nokta Türü",
    "Partners": "İş Ortakları",
    "Recargar Credito": "Kredi Yükle",
    "Torneos y Bonos": "Turnuvalar ve Bonuslar",
    "Mi Configuracion": "Yapılandırmam",
    "Partners Proveedores": "İş Ortağı Sağlayıcıları",
    "Partners Tipo Producto": "İş Ortağı Ürün Türü",
    "Partners Productos": "İş Ortağı Ürünleri",
    "Partners Productos Pais": "Ülke İş Ortağı Ürünleri",
    "Categorias": "Kategoriler",
    "Categorías Productos": "Ürün Kategorileri",
    "Jugadores": "Oyuncular",
    "Jugadores Partner": "İş Ortağı Oyuncuları",
    "Jugadores Aggregator": "Toplayıcı Oyuncuları",
    "Reporte de depósitos": "Para yatırma raporu",
    "Autoexclusiones de Usuario": "Kullanıcı Kendi Kendini Men Etme",
    "Reporte de casino": "Casino raporu",
    "Reporte de Saldos": "Bakiye raporu",
    "Reporte de bonos": "Bonus raporu",
    "Reporte de Jugadores": "Oyuncu raporu",
    "Flujo de Caja Histórico": "Geçmiş Nakit Akışı",
    "Flujo de Caja Resumido": "Özetlenmiş Nakit Akışı",
    "Informe Gerencial": "Yönetim Raporu",
    "Usuario online Resumido": "Özetlenmiş Çevrimiçi Kullanıcı",
    "Usuario - Agregator": "Kullanıcı - Toplayıcı",
    "Premios pendientes por pagar": "Ödenecek bekleyen ödüller",
    "Reporte de Sesiones": "Oturum Raporu",
    "Reporte de Ajustes de Saldos": "Bakiye Düzeltme Raporu",
    "Reporte Trans. Sportbook": "Spor Bahisleri İşlem Raporu",
    "Reporte de  Movimientos Saldo": "Bakiye Hareketleri Raporu",
    "Historico de  Saldos": "Bakiye Geçmişi",
    "Documentos Registrados": "Kayıtlı Belgeler",
    "Contabilidad": "Muhasebe",
    "Centros de costo": "Maliyet merkezleri",
    "Estructural": "Yapısal",
    "Cuentas": "Hesaplar",
    "Cierres de Caja": "Kasa Kapanışları",
    "Seguridad": "Güvenlik",
    "Aprobar logs": "Logları onayla",
    "Usuarios administrativos": "Yönetici kullanıcılar",
    "Usuarios Bloqueados": "Engellenen kullanıcılar",
    "Contingencia": "Acil Durum",
    "Menus": "Menüler",
    "Perfiles": "Profiller",
    "Perfiles - Options": "Profiller - Seçenekler",
    "Sub Menu": "Alt Menü",
    "Usuario Perfil": "Kullanıcı Profili",
    "Gestion": "Yönetim",
    "Codigos Promocionales": "Promosyon Kodları",
    "Activar Registros": "Kayıtları Etkinleştir",
    "Ajustar pasarela de pago": "Ödeme ağ geçidini ayarla",
    "Asignacion de cupo": "Kota ataması",
    "Eliminar nota de retiro": "Para çekme notunu sil",
    "Manejar red": "Ağı yönet",
    "Registro rapido": "Hızlı kayıt",
    "Reimprimir cheque": "Çeki yeniden yazdır",
    "Reversion": "Geri Alma",
    "Trabaja con nosotros": "Bizimle çalış",
    "Caja": "Kasa",
    "Pago Premio": "Ödül Ödemesi",
    "Pago Nota Retiro": "Para Çekme Notu Ödemesi",
    "Lista": "Liste",
    "Maquinas": "Makineler",
    "Registrar": "Kaydet",
    "Pago Nota de cobro": "Tahsilat Notu Ödemesi",
    "Maquinas Grafica": "Makineler Grafiği",
    "Herramientas": "Araçlar",
    "Partner Ajustes": "İş Ortağı Ayarları",
    "Traducción": "Çeviri",
    "Subir imagen": "Resim yükle",
    "Gestión Punto de Venta": "Satış Noktası Yönetimi",
    "Gestión Puntos Gráfico": "Nokta Yönetimi Grafiği",
    "Puntos de venta Competencia": "Rakip Satış Noktaları",
    "Agentes": "Ajanlar",
    "Lista de Agentes": "Ajanlar Listesi",
    "Árbol de Agentes": "Ajanlar Ağacı",
    "Informe de Agentes": "Ajanlar Raporu",
    "Transferencias": "Transferler",
    "Solicitudes": "Talepler",
    "Solicitudes de Retiro": "Para Çekme Talepleri",
    "Solicitudes de Deposito": "Para Yatırma Talepleri",
    "Cierre de caja": "Kasa kapanışı",
    "Inicio Día": "Gün Başlangıcı",
    "Fecha:": "Tarih:",
    "Valor Inicio de día:": "Gün başlangıç değeri:",
    "Agregar imagen": "Resim ekle",
    "Añadir Proveedor Partner": "İş Ortağı Sağlayıcı Ekle",
    "Proveedor Partner": "İş Ortağı Sağlayıcı",
    "Tipo Producto Partner": "İş Ortağı Ürün Türü",
    "Saldo Depósitos:": "Para Yatırma Bakiyesi:",
    "Tipo de integración": "Entegrasyon türü",
    "Pasarela de Pagos": "Ödeme Ağ Geçidi",
    "Lobby con token propio": "Kendi tokenli lobi",
    "Lobby con token de proveedor": "Sağlayıcı tokenli lobi",
    "Productos Partner": "İş Ortağı Ürünleri",
    "Automático": "Otomatik",
    "Partners Productos País": "Ülke İş Ortağı Ürünleri",
    "Lista de Jugadores": "Oyuncular Listesi",
    "Bloqueados": "Engellenenler",
    "DNI Anterior": "Önceki Kimlik",
    "No tiene DNI Anterior": "Önceki Kimlik Yok",
    "DNI Posterior": "Sonraki Kimlik",
    "No tiene DNI Posterior": "Sonraki Kimlik Yok",
    "Descargar": "İndir",
    "Tipo de Documento": "Belge Türü",
    "Cedula de Extranjería": "Yabancı Kimlik Kartı",
    "Subir DNI Anterior": "Önceki Kimliği Yükle",
    "Subir DNI Posterior": "Sonraki Kimliği Yükle",
    "Finanzas": "Finans",
    "Resumen": "Özet",
    "Reporte Autoexclusión": "Kendi Kendini Men Etme Raporu",
    "Reporte de Sesiones": "Oturum Raporu",
    "Registro de Documentos": "Belge Kaydı",
    "Ver más": "Daha fazla gör",
    "Historial de saldo": "Bakiye geçmişi",
    "Historial de movimientos": "Hareket geçmişi",
    "Logs Usuario": "Kullanıcı Logları",
    "Valor Mínimo": "Minimum Değer",
    "Valor Máximo": "Maksimum Değer",
    "Premio Total Máximo": "Maksimum Toplam Ödül",
    "Premio Total Mínimo": "Minimum Toplam Ödül",
    "Crear Token Personalizado": "Özelleştirilmiş Token Oluştur",
    "Crear Token": "Token Oluştur",
    "Token": "Token",
    "Token Creado": "Token Oluşturuldu",
    "Cancelar Cuenta": "Hesabı İptal Et",
    "Desea cancelar la cuenta de el usuario?": "Kullanıcının hesabını iptal etmek istiyor musunuz?",
    "Resumen por Proveedor": "Sağlayıcıya Göre Özet",
    "Tipo Pasarela de Pago": "Ödeme Ağ Geçidi Türü",
    "Proveedor pasarela de pago": "Ödeme ağ geçidi sağlayıcısı",
    "Usuarios Autoexcluidos": "Kendi Kendini Men Eden Kullanıcılar",
    "Cantidad": "Miktar",
    "Saldo Gratis": "Ücretsiz Bakiye",
    "Envió": "Gönderildi",
    "Reporte de Saldos Online": "Çevrimiçi Bakiye Raporu",
    "Añadir bono a saldo": "Bakiyeye bonus ekle",
    "Bono a saldo añadido correctamente": "Bonus bakiyeye başarıyla eklendi",
    "Tipo de Detalle": "Detay Türü",
    "Apuesta": "Bahis",
    "Apuesta Promedio": "Ortalama Bahis",
    "Usuarios Registrados": "Kayıtlı Kullanıcılar",
    "Primeros Depósitos": "İlk Para Yatırmalar",
    "Usuario Id": "Kullanıcı Id",
    "Cant Tickets Casino": "Casino Kupon Sayısı",
    "Cant Tickets Casino Vivo": "Canlı Casino Kupon Sayısı",
    "Total Tickets": "Toplam Kupon",
    "Saldo Disp Retiro": "Çekilebilir Bakiye",
    "Nota de retiro pendiente": "Bekleyen para çekme notu",
    "Vlr Ap. Casino": "Casino Bahis D.",
    "Vlr Ap. Casino Vivo": "Canlı Casino Bahis D.",
    "Total Apostado": "Toplam Bahis",
    "Vlr Pr. Casino": "Casino Ödül D.",
    "Vlr Pr. Casino Vivo": "Canlı Casino Ödül D.",
    "Total premios": "Toplam ödüller",
    "Saldo Recargas": "Yükleme Bakiyesi",
    "Valor Recargas": "Yükleme Değeri",
    "Valor premios": "Ödül değeri",
    "Relación Usuario Aggregato": "Toplayıcı Kullanıcı İlişkisi",
    "Usuario Partner": "İş Ortağı Kullanıcısı",
    "Usuario Aggregator": "Toplayıcı Kullanıcısı",
    "Añadir Relación": "İlişki Ekle",
    "Editar Relación": "İlişkiyi Düzenle",
    "Hora de creación": "Oluşturma saati",
    "Fecha Premio": "Ödül Tarihi",
    "Hora Premio": "Ödül Saati",
    "Transacciones deportivas": "Spor işlemleri",
    "Saldo Inicial": "Başlangıç Bakiyesi",
    "Ap. Deportivas": "Spor Bahisleri",
    "Pr. Deportivas": "Spor Ödülleri",
    "Ap. Casino": "Casino Bahisleri",
    "Pr. Casino": "Casino Ödülleri",
    "Retiros Creados": "Oluşturulan Çekimler",
    "Retiros Eliminados": "Silinen Çekimler",
    "Ajustes E": "Giriş Düzeltmeleri",
    "Ajustes S": "Çıkış Düzeltmeleri",
    "Saldo Final": "Son Bakiye",
    "Saldo Final Calc.": "Hesaplanan Son Bakiye",
    "Retiros Pagados": "Ödenen Çekimler",
    "Retiros Pendientes": "Bekleyen Çekimler",
    "Bonos Free Ganados": "Kazanılan Ücretsiz Bonuslar",
    "Añadir Documento": "Belge Ekle",
    "Editar Documento": "Belgeyi Düzenle",
    "Puntos de Venta": "Satış Noktaları",
    "Saldo Juego": "Oyun Bakiyesi",
    "Datos Punto de venta": "Satış noktası verileri",
    "Configuración Punto de Venta": "Satış Noktası Yapılandırması",
    "Contraseña": "Şifre",
    "Forma de pago": "Ödeme şekli",
    "Modificó": "Değiştiren",
    "Nombre del sistema de pasarela de pago": "Ödeme ağ geçidi sistemi adı",
    "Tipo de tiempo": "Zaman türü",
    "Resultado": "Sonuç",
    "Fecha Resultado": "Sonuç Tarihi",
    "Reporte Flujo de Caja": "Nakit Akışı Raporu",
    "Rollover Apostado": "Çevrilen Miktar",
    "Rollover Restante": "Kalan Çevrim",
    "Estado de Recarga": "Yükleme Durumu",
    "Actualizar IP": "IP Güncelle",
    "Punto de Venta:": "Satış Noktası:",
    "ID Sesión": "Oturum ID",
    "Tipo de Cierre": "Kapanış Türü",
    "Sistema": "Sistem",
    "Hora Fin": "Bitiş Saati",
    "Geolocalización": "Coğrafi Konum",
    "Monto Apostado": "Bahis Tutarı",
    "Créditos Promocionales Recibidos": "Alınan Promosyon Kredileri",
    "Créditos Promocionales Apostados": "Bahis Yapılan Promosyon Kredileri",
    "Motivo Cierre": "Kapanış Nedeni",
    "Saldo al Iniciar": "Başlangıç Bakiyesi",
    "Saldo al Final": "Bitiş Bakiyesi",
    "Monto Ganado": "Kazanılan Tutar",
    "Sistema operativo": "İşletim sistemi",
    "Inicio de sesión fallidos": "Başarısız giriş denemeleri",
    "Cambio realizado a la cuenta": "Hesapta yapılan değişiklik",
    "Cuenta cancelada": "Hesap iptal edildi",
    "Arrastra Negativos": "Negatifleri Sürükle",
    "Estadísticas": "İstatistikler",
    "Estadisticas": "İstatistikler",
    "Añadir Agente:": "Ajan Ekle:",
    "Eliminado": "Silindi",
    "Devueltas": "İade Edilenler",
    "Añadir Código": "Kod Ekle",
    "Editar Código": "Kodu Düzenle",
    "Visitas Links": "Bağlantı Ziyaretleri",
    "Registros": "Kayıtlar",
    "Edad": "Yaş",
    "Informe Red": "Ağ Raporu",
    "Realizar Transferencia": "Transfer Yap",
    "Apellidos": "Soyadlar",
    "Productos Terceros": "Üçüncü Taraf Ürünleri",
    "Depositos": "Para Yatırma",
    "JUGADORES ACTIVOS": "AKTİF OYUNCULAR",
    "APUESTAS": "BAHİSLER",
    "PREMIOS PAGADOS": "ÖDENEN ÖDÜLLER",
    "Aprobación Logs": "Log Onayı",
    "Aprobar log": "Logu onayla",
    "Administración de Usuarios": "Kullanıcı Yönetimi",
    "Administración de Usuarios Bloqueados": "Engellenen Kullanıcıların Yönetimi",
    "Usuario:": "Kullanıcı:",
    "Usuario es de País": "Kullanıcı Ülkedendir",
    "Usuario es Global": "Kullanıcı Globaldir",
    "Activar Usuario País": "Ülke Kullanıcısını Etkinleştir",
    "Inactivar Usuario País": "Ülke Kullanıcısını Devre Dışı Bırak",
    "Añadir Usuario:": "Kullanıcı Ekle:",
    "Perfil Opciones": "Profil Seçenekleri",
    "Códigos promocionales": "Promosyon kodları",
    "Función": "İşlev",
    "Registro": "Kayıt",
    "Activar Registro": "Kaydı Etkinleştir",
    "Gestión Contacto": "İletişim Yönetimi",
    "Fecha/Hora Creación": "Oluşturma Tarihi/Saati",
    "Nombres": "Adlar",
    "Crear Nota": "Not Oluştur",
    "Terminado": "Bitti",
    "Pago Nota de Retiro": "Para Çekme Notu Ödemesi",
    "Máquinas": "Makineler",
    "Añadir Máquina": "Makine Ekle",
    "Añadir Máquina:": "Makine Ekle:",
    "Teléfono Mobile": "Cep Telefonu",
    "Recargar Máquina": "Makine Yükle",
    "Actualizar Máquina": "Makineyi Güncelle",
    "Actualizar Versión": "Sürümü Güncelle",
    "Actualizar Máquina": "Makineyi Güncelle",
    "Publicidad": "Reklam",
    "Estado de Máquina": "Makine Durumu",
    "Pago Nota de Cobro": "Tahsilat Notu Ödemesi",
    "Máquinas Grafica": "Makineler Grafiği",
    "Solicitud de retiro de clientes": "Müşteri para çekme talepleri",
    "Solicitud de depósito de clientes": "Müşteri para yatırma talepleri",
    "Ajustes Generales": "Genel Ayarlar",
    "Nombre Compañía": "Şirket Adı",
    "Días de expiración de la contraseña": "Şifre geçerlilik süresi (gün)",
    "Regular Expresión contraseña usuario": "Kullanıcı şifresi için düzenli ifade",
    "Días de expiración contraseña temporal": "Geçici şifre geçerlilik süresi (gün)",
    "Mínima longitud de la contraseña": "Minimum şifre uzunluğu",
    "Días antes de notificación de expiración": "Sona ermeden önceki bildirim günleri",
    "Expresión regular que valide una contraseña.": "Bir şifreyi doğrulayan düzenli ifade.",
    "Ej: Que tenga entre 4 y 16 caracteres.": "Örn: 4 ila 16 karakter arasında olması.",
    "Cuantos días antes de que expire la contraseña, se le notificara el cambio": "Şifrenin süresi dolmadan kaç gün önce değişiklik bildirilecektir",
    "Máximo solicitudes por día": "Günlük maksimum talep sayısı",
    "Porcentaje mínimo apostado/depositado": "Minimum bahis yapılan/yatırılan yüzde",
    "Porcentaje mínimo apostado sobre lo depositado": "Yatırılan tutar üzerinden minimum bahis yüzdesi",
    "Especifique el porcentaje mínimo apostado sobre lo depositado.": "Yatırılan tutar üzerinden minimum bahis yüzdesini belirtin.",
    "Mínimo monto en solicitud de retiro": "Minimum para çekme talebi tutarı",
    "Máximo monto en solicitud de retiro": "Maksimum para çekme talebi tutarı",
    "Máxima cantidad de solicitudes activas": "Maksimum aktif talep sayısı",
    "Mínimo monto de solicitud de deposito": "Minimum para yatırma talebi tutarı",
    "Máximo monto de solicitud de deposito": "Maksimum para yatırma talebi tutarı",
    "Impuesto Retiro Saldo Deposito": "Para Yatırma Bakiyesi Çekim Vergisi",
    "Impuesto Retiro Saldo Premios a partir de": "Ödül Bakiyesi Çekim Vergisi (şu tutardan itibaren)",
    "Impuesto por Retiro Saldo Premios a partir de un valor.": "Belirli bir değerden itibaren Ödül Bakiyesi Çekim Vergisi.",
    "Aprobar cuentas bancarias?": "Banka hesaplarını onayla?",
    "Porcentaje Penalidad Retiro Saldo Retiros": "Çekim Bakiyesi Çekim Ceza Yüzdesi",
    "Especifique el porcentaje de la penalidad por retiro a saldo de retiros.": "Çekim bakiyesinden çekim için ceza yüzdesini belirtin.",
    "Días para alerta de actualización de datos": "Veri güncelleme uyarısı için gün sayısı",
    "Días para alerta de actualización de datos del usuario.": "Kullanıcı veri güncelleme uyarısı için gün sayısı.",
    "Impuesto Retiro Saldo Premios": "Ödül Bakiyesi Çekim Vergisi",
    "Impuesto al ente regulador a partir de": "Düzenleyici kuruma vergi (şu tutardan itibaren)",
    "Aprobar cambios de información personal?": "Kişisel bilgi değişikliklerini onayla?",
    "Aprobar los cambios de información personal hechos por el usuario?": "Kullanıcı tarafından yapılan kişisel bilgi değişikliklerini onayla?",
    "Mínimo Retiro de Saldo Retiros para Penalizar": "Cezalandırmak için Minimum Çekim Bakiyesi Çekimi",
    "Especifique el monto mínimo de retiro de saldo retiros para penalizar.": "Cezalandırmak için minimum çekim bakiyesi çekim tutarını belirtin.",
    "Días para alerta de cambio de contraseña": "Şifre değişikliği uyarısı için gün sayısı",
    "Impuesto al ente regulador": "Düzenleyici kuruma vergi",
    "Impuesto premios por punto de venta físico": "Fiziksel satış noktası ödül vergisi",
    "Impuesto a los premios reclamados por punto de venta físico": "Fiziksel satış noktasından talep edilen ödüllere vergi",
    "Máximo cuentas bancarias": "Maksimum banka hesabı sayısı",
    "Porcentaje Penalidad Retiro Saldo Recargas": "Yükleme Bakiyesi Çekim Ceza Yüzdesi",
    "Especifique el porcentaje de la penalidad por retiro a saldo de recargas.": "Yükleme bakiyesinden çekim için ceza yüzdesini belirtin.",
    "Porcentaje Invalido": "Geçersiz Yüzde",
    "Inactividad de sesión en minutos": "Oturum hareketsizlik süresi (dakika)",
    "Establezca el tiempo de inactividad en minutos para el cierre de sesión.": "Oturumun kapatılması için hareketsizlik süresini dakika olarak ayarlayın.",
    "Duración de la sesión en minutos": "Oturum süresi (dakika)",
    "Establezca la duración de la sesión de juego en minutos.": "Oyun oturumunun süresini dakika olarak ayarlayın.",
    "URL fondo casino": "Casino arka plan URL'si",
    "Establezca la URL de la imagen para fondo de casino.": "Casino arka planı için resim URL'sini ayarlayın.",
    "Impuesto Retiro Saldo Deposito a partir de": "Para Yatırma Bakiyesi Çekim Vergisi (şu tutardan itibaren)",
    "Impuesto por Retiro Saldo Deposito a partir de un valor": "Belirli bir değerden itibaren Para Yatırma Bakiyesi Çekim Vergisi",
    "Requiere registro activo para iniciar sesión?": "Giriş yapmak için aktif kayıt gerekiyor mu?",
    "Mínimo Retiro de Recargas para Penalizar": "Cezalandırmak için Minimum Yükleme Çekimi",
    "Especifique el monto mínimo de retiro de saldo recargas para penalizar.": "Cezalandırmak için minimum yükleme bakiyesi çekim tutarını belirtin.",
    "Liquidaciones generadas": "Oluşturulan tasfiyeler",
    "Contigencia Total": "Toplam Acil Durum",
    "Automáticas": "Otomatik",
    "Manuales": "Manuel",
    "Informacíon Actualizada": "Bilgi Güncellendi",
    "Días de expiración de la contraseña temporal": "Geçici şifre geçerlilik süresi (gün)",
    "Solicitudes de Depósitos": "Para Yatırma Talepleri",
    "Recepción de Efectivo": "Nakit Alımı",
    "Aprobar Depósito": "Para Yatırmayı Onayla",
    "Rechazar Depósito": "Para Yatırmayı Reddet",
    "Método de pago cuentas bancarias": "Banka hesapları ödeme yöntemi",
    "Pagado físicamente": "Fiziksel olarak ödendi",
    "Pagado por sistema": "Sistem tarafından ödendi",
    "Método de pago": "Ödeme yöntemi",
    "Aprobar Nota": "Notu Onayla",
    "Desea Aprobar Nota de Retiro?": "Para Çekme Notunu Onaylamak İstiyor musunuz?",
    "Rechazar Nota": "Notu Reddet",
    "Desea Rechazar Nota de Retiro?": "Para Çekme Notunu Reddetmek İstiyor musunuz?",
    "Ver por un cajero en especifico": "Belirli bir kasiyere göre görüntüle",
    "Volver": "Geri",
    "Ingresos Tarjetas de crédito": "Kredi Kartı Gelirleri",
    "Otros Egresos": "Diğer Giderler",
    "Añadir ingreso por tarjeta": "Kartla gelir ekle",
    "Cerrar día": "Günü kapat",
    "No hay datos": "Veri yok",
    "Especifique si el usuario quedara automáticamente activado después del registro": "Kullanıcının kayıttan sonra otomatik olarak etkinleştirilip etkinleştirilmeyeceğini belirtin",
    "Usuario automáticamente activado": "Kullanıcı otomatik olarak etkinleştirildi",
    "Limite depósito día por defecto": "Varsayılan günlük para yatırma limiti",
    "Especifique el límite de depósito diario por defecto": "Varsayılan günlük para yatırma limitini belirtin",
    "Limite depósito semana por defecto": "Varsayılan haftalık para yatırma limiti",
    "Especifique el límite de depósito semanal por defecto": "Varsayılan haftalık para yatırma limitini belirtin",
    "Limite depósito mes por defecto": "Varsayılan aylık para yatırma limiti",
    "Especifique el límite de depósito mensual por defecto": "Varsayılan aylık para yatırma limitini belirtin",
    "Limite depósito día global": "Global günlük para yatırma limiti",
    "Especifique el límite de depósito diario global": "Global günlük para yatırma limitini belirtin",
    "Limite depósito semana global": "Global haftalık para yatırma limiti",
    "Especifique el límite de depósito semanal global": "Global haftalık para yatırma limitini belirtin",
    "Limite depósito mes global": "Global aylık para yatırma limiti",
    "Especifique el límite de depósito mensual global": "Global aylık para yatırma limitini belirtin",
    "Máximo intentos inicio sesión": "Maksimum giriş denemesi sayısı",
    "Especifique el número máximo de intentos para iniciar sesión": "Giriş yapmak için maksimum deneme sayısını belirtin",
    "Mínimo retiros punto": "Minimum nokta çekimleri",
    "Mínimo monto en solicitud de retiro por punto de venta": "Satış noktası başına minimum para çekme talebi tutarı",
    "Competidor": "Rakip",
    "Desea cancelar la cuenta del punto de venta?": "Satış noktasının hesabını iptal etmek istiyor musunuz?",
    "Fecha Pagado": "Ödeme Tarihi",
    "Tipo de cuenta": "Hesap türü",
    "Configuración Partner": "İş Ortağı Yapılandırması",
    "No tienes un QR Configurado, por favor comunicarse con soporte.": "Yapılandırılmış bir QR kodunuz yok, lütfen destek ile iletişime geçin.",
    "Zona horaria:": "Saat dilimi:",
    "Moneda para reportes": "Raporlar için para birimi",
    "Impuesto sobre apuesta al pagar premio": "Ödül öderken bahis üzerinden vergi",
    "Impuesto sobre el monto de la apuesta al momento de pagar el premio": "Ödülü öderken bahis tutarı üzerinden vergi",
    "Verificó DNI posterior?": "Sonraki kimlik doğrulandı mı?",
    "Verificó DNI anterior?": "Önceki kimlik doğrulandı mı?",
    "Tipo de liquidaciones comisiones": "Komisyon tasfiye türü",
    "Especifique el tipo de liquidaciones para las comisiones, sea por caja o por cierre.": "Komisyonlar için tasfiye türünü belirtin, kasa veya kapanışa göre.",
    "Cierre": "Kapanış",
    "Cierre Pagada": "Kapanış Ödendi",
    "El usuario o la clave son incorrectos. (Report#30003)": "Kullanıcı veya şifre yanlış. (Rapor#30003)",
    "Total Caja:": "Toplam Kasa:",
    "Se cerró el día satisfactoriamente": "Gün başarıyla kapatıldı",
    "Ya se efectuó el cierre de día, nos es posible realizar esta operación": "Gün kapanışı zaten yapıldı, bu işlemi gerçekleştirmek mümkün değil",
    "Ticket Ganador": "Kazanan Kupon",
    "Ticket Perdedor": "Kaybeden Kupon",
    "Ticket Pendiente": "Bekleyen Kupon",
    "Premio Pagado": "Ödül Ödendi",
    "Ticket no encontrado": "Kupon bulunamadı",
    "Nota de retiro no encontrada": "Para çekme notu bulunamadı",
    "Nota de retiro pagada": "Para çekme notu ödendi",
    "Confirmar Valor:": "Değeri Onayla:",
    "Confirmar Valor": "Değeri Onayla",
    "Valores no coinciden": "Değerler eşleşmiyor",
    "Ya se efectuó el cierre de día, no es posible realizar esta operación": "Gün kapanışı zaten yapıldı, bu işlemi gerçekleştirmek mümkün değil",
    "Apuestas Deportivas": "Spor Bahisleri",
    "Apuestas deportivas en vivo": "Canlı spor bahisleri",
    "Apuestas Virtuales": "Sanal Bahisler",
    "El usuario no se encuentra o ya fue activado": "Kullanıcı bulunamadı veya zaten etkinleştirildi",
    "Premio pagado satisfactoriamente": "Ödül başarıyla ödendi",
    "ID Afiliador": "Ortak ID",
    "Nombre Afiliador": "Ortak Adı",
    "Recargas Eliminadas": "Silinen Yüklemeler",
    "Cupo Recarga E": "Yükleme Kotası G",
    "Cupo Recarga S": "Yükleme Kotası Ç",
    "Cupo recargas inicial": "Başlangıç yükleme kotası",
    "Cupo juego inicial": "Başlangıç oyun kotası",
    "Cupo recargas final": "Son yükleme kotası",
    "Cupo recargas final Calc.": "Hesaplanan son yükleme kotası",
    "Cupo juego final": "Son oyun kotası",
    "Cupo juego final Calc.": "Hesaplanan son oyun kotası",
    "Historial de saldo punto de venta": "Satış noktası bakiye geçmişi",
    "Cupo Apuesta E": "Bahis Kotası G",
    "Cupo Apuesta S": "Bahis Kotası Ç",
    "Punto de venta propio?": "Kendi satış noktası mı?",
    "Tipos de documentos": "Belge türleri",
    "Tipo de documento agregado": "Belge türü eklendi",
    "Tipo de documento actualizado": "Belge türü güncellendi",
    "Añadir tipo de documento": "Belge türü ekle",
    "Editar tipo de documento": "Belge türünü düzenle",
    "Serie:": "Seri:",
    "Tipo documento:": "Belge türü:",
    "Impuesto:": "Vergi:",
    "Saldo Antes de Ajuste": "Düzeltme Öncesi Bakiye",
    "Saldo Despues de Ajuste": "Düzeltme Sonrası Bakiye",
    "Numero Autoexclusiónes": "Kendi Kendini Men Etme Sayısı",
    "Motivo Autoexclusión": "Kendi Kendini Men Etme Nedeni",
    "Fondos Depositados": "Yatırılan Fonlar",
    "Fondos Retirados": "Çekilen Fonlar",
    "Fondos Restantes de Juegos Incompletos": "Tamamlanmamış Oyunlardan Kalan Fonlar",
    "Requiere registro activo para depositar?": "Para yatırmak için aktif kayıt gerekiyor mu?",
    "Especifique si el usuario necesita tener el registro activado para poder depositar": "Kullanıcının para yatırmak için kaydının etkin olması gerekip gerekmediğini belirtin",
    "Requiere verificación de cuenta para depositar?": "Para yatırmak için hesap doğrulaması gerekiyor mu?",
    "Especifique si el usuario necesita verificar cuenta para poder depositar": "Kullanıcının para yatırmak için hesabını doğrulaması gerekip gerekmediğini belirtin",
    "Requiere registro activo para retirar?": "Para çekmek için aktif kayıt gerekiyor mu?",
    "Especifique si el usuario necesita tener el registro activado para poder retirar": "Kullanıcının para çekmek için kaydının etkin olması gerekip gerekmediğini belirtin",
    "Requiere verificación de cuenta para retirar?": "Para çekmek için hesap doğrulaması gerekiyor mu?",
    "Especifique si el usuario necesita verificar cuenta para poder retirar": "Kullanıcının para çekmek için hesabını doğrulaması gerekip gerekmediğini belirtin",
    "Tipo de comisión puntos de venta": "Satış noktaları komisyon türü",
    "Especifique el tipo de comisión para los puntos de venta.": "Satış noktaları için komisyon türünü belirtin.",
    "Logs Usuario General": "Genel Kullanıcı Logları",
    "Ordenar por": "Sırala",
    "Orden": "Sıra",
    "Ascendente": "Artan",
    "Descendente": "Azalan",
    "Cajero": "Kasiyer",
    "Historico Saldos Punto Venta": "Satış Noktası Bakiye Geçmişi",
    "Reporte Comisiones Global": "Global Komisyon Raporu",
    "Desea cerrar día?": "Günü kapatmak istiyor musunuz?",
    "Impuestos": "Vergiler",
    "Fecha de exportación:": "Dışa aktarma tarihi:",
    "Confirme recarga de": "Yüklemeyi onayla",
    "para el usuario": "kullanıcı için",
    "Tipo de Saldo": "Bakiye Türü",
    "Saldo de Recargas": "Yükleme Bakiyesi",
    "Continuar": "Devam Et",
    "Reporte de Transferencias": "Transfer Raporu",
    "Usuario Creó": "Oluşturan Kullanıcı",
    "Usuario Recibió": "Alan Kullanıcı",
    "Fecha de reporte: Desde": "Rapor tarihi: Başlangıç",
    "Hasta": "Bitiş",
    "Desea Rechazar la Retracción de Saldo?": "Bakiye Geri Çekimini Reddetmek İstiyor musunuz?",
    "Estado de Retracción actualizado": "Geri Çekme durumu güncellendi",
    "Desea Aprobar el Retracción de Saldo?": "Bakiye Geri Çekimini Onaylamak İstiyor musunuz?",
    "Estado de Retracción actualizado": "Geri Çekme durumu güncellendi",
    "Aprobación de Retracción de Saldo": "Bakiye Geri Çekme Onayı",
    "Te estas logueando desde el sitio equivocado.": "Yanlış siteden giriş yapıyorsunuz.",
    "¡Serás redireccionado a tu sitio!": "Sitenize yönlendirileceksiniz!",
    "¡Atención!": "Dikkat!",
    "IR AL SITIO": "SİTEYE GİT",
    "Punto Venta Pagó": "Satış Noktası Ödedi",
    "¿Es de movimiento de base de caja?": "Kasa tabanı hareketinden mi?",
    "Centro de costo personalizado": "Özelleştirilmiş maliyet merkezi",
    "Apuestas Anuladas": "İptal Edilen Bahisler",
    "Apuestas Pagadas Anuladas": "İptal Edilen Ödenmiş Bahisler",
    "Estado Celular": "Cep Telefonu Durumu",
    "Sin verificar": "Doğrulanmamış",
    "Descripción del reporte: Flujo Caja Resumido": "Rapor açıklaması: Özet Nakit Akışı",
    "Fecha creación del reporte:": "Rapor oluşturma tarihi:",
    "Flujo Caja Resumido": "Özet Nakit Akışı",
    "Sub Diario": "Alt Günlük",
    "Número de Comprobante": "Fiş Numarası",
    "Fecha de Comprobante": "Fiş Tarihi",
    "Código de Moneda": "Para Birimi Kodu",
    "Glosa Principal": "Ana Açıklama",
    "Tipo de Cambio": "Döviz Kuru",
    "Tipo de Conversión": "Dönüşüm Türü",
    "Flag de Conversión de Moneda": "Para Birimi Dönüşüm Bayrağı",
    "Fecha Tipo de Cambio": "Döviz Kuru Tarihi",
    "Cuenta Contable": "Muhasebe Hesabı",
    "Código de Anexo": "Ek Kodu",
    "Código de Centro de Costo": "Maliyet Merkezi Kodu",
    "Debe / Haber": "Borç / Alacak",
    "Importe Original": "Orijinal Tutar",
    "Importe en Dólares": "Dolar Cinsinden Tutar",
    "Importe en Soles": "Sol Cinsinden Tutar",
    "Tipo de Documento": "Belge Türü",
    "Número de Documento": "Belge Numarası",
    "Fecha de Documento": "Belge Tarihi",
    "Fecha de Vencimiento": "Vade Tarihi",
    "Código de Area": "Alan Kodu",
    "Glosa Detalle": "Detay Açıklama",
    "Código de Anexo Auxiliar": "Yardımcı Ek Kodu",
    "Medio de Pago": "Ödeme Yöntemi",
    "Tipo de Documento de Referencia": "Referans Belge Türü",
    "Número de Documento Referencia": "Referans Belge Numarası",
    "Fecha Documento Referencia": "Referans Belge Tarihi",
    "Nro Máq. Registradora Tipo Doc. Ref.": "Kayıt Cihazı Mak. No. Ref. Belge Türü",
    "Base Imponible Documento Referencia": "Referans Belgesi Vergi Matrahı",
    "IGV Documento Provisión": "Karşılık Belgesi KDV",
    "Tipo Referencia en estado MQ": "MQ durumunda Referans Türü",
    "Número Serie Caja Registradora": "Yazar Kasa Seri Numarası",
    "Fecha de Operación": "İşlem Tarihi",
    "Tipo de Tasa": "Oran Türü",
    "Tasa Detracción/Percepción": "Tevkifat/Algı Oranı",
    "Importe Base Detracción/Percepción Dólares": "Dolar Cinsinden Tevkifat/Algı Baz Tutarı",
    "Importe Base Detracción/Percepción Soles": "Sol Cinsinden Tevkifat/Algı Baz Tutarı",
    "Tipo Cambio para F": "F için Kur Türü",
    "Importe de IGV sin derecho crédito fiscal": "Vergi kredisi hakkı olmayan KDV tutarı",
    "Ver T.G. 02": "Bkz. T.G. 02",
    "Los dos primeros dígitos son el mes y los otros 4 siguientes un correlativo": "İlk iki hane aysonraki 4 hane ise ardışık bir sayıdır",
    "Ver T.G. 03": "Bkz. T.G. 03",
    "Llenar  solo si Tipo de Conversión es 'C'. Debe estar entre >=0 y <=9999.999999": "Yalnızca Dönüşüm Türü 'C' ise doldurun. >=0 ve <=9999.999999 arasında olmalıdır",
    "Solo: 'C'= Especial, M'=Compra, V'=Venta, F' De acuerdo a fecha": "Yalnızca: 'C'= Özel, 'M'=Alış, 'V'=Satış , 'F' Tarihe göre",
    "Solo: 'S' = Si se convierte, N'= No se convierte": "Yalnızca: 'S' = Dönüştürülürse, 'N'= Dönüştürülmezse",
    "Si  Tipo de Conversión 'F'": "Eğer Dönüşüm Türü 'F' ise",
    "Debe existir en el Plan de Cuentas": "Hesap Planında mevcut olmalıdır",
    "Si Cuenta Contable tiene seleccionado Tipo de Anexo, debe existir en la tabla de Anexos": "Muhasebe Hesabı'nda Ek Türü seçiliyse, Ekler tablosunda mevcut olmalıdır",
    "Si Cuenta Contable tiene habilitado C. Costo, Ver T.G. 05": "Muhasebe Hesabı'nda Maliyet Merkezi etkinse, Bkz. T.G. 05",
    "D' ó 'H'": "B' veya 'A'",
    "Importe original de la cuenta contable. Obligatorio, debe estar entre >=0 y <=99999999999.99": "Muhasebe hesabının orijinal tutarı. Zorunlu, >=0 ve <=99999999999.99 arasında olmalıdır",
    "Importe de la Cuenta Contable en Dólares. Obligatorio si Flag de Conversión de Moneda esta en 'N', debe estar entre >=0 y <=99999999999.99": "Dolar Cinsinden Muhasebe Hesabı Tutarı. Para Birimi Dönüşüm Bayrağı 'N' ise zorunlu, >=0 ve <=99999999999.99 arasında olmalıdır",
    "Importe de la Cuenta Contable en Soles. Obligatorio si Flag de Conversión de Moneda esta en 'N', debe estra entre >=0 y <=99999999999.99": "Sol Cinsinden Muhasebe Hesabı Tutarı. Para Birimi Dönüşüm Bayrağı 'N' ise zorunlu, >=0 ve <=99999999999.99 arasında olmalıdır",
    "Si Cuenta Contable tiene habilitado el Documento Referencia Ver T.G. 06": "Muhasebe Hesabı'nda Referans Belgesi etkinse Bkz. T.G. 06",
    "Si Cuenta Contable tiene habilitado el Documento Referencia Incluye Serie y Número": "Muhasebe Hesabı'nda Referans Belgesi Seri ve Numarayı İçerir etkinse",
    "Si Cuenta Contable tiene habilitado el Documento Referencia": "Muhasebe Hesabı'nda Referans Belgesi etkinse",
    "Si Cuenta Contable tiene habilitada la Fecha de Vencimiento": "Muhasebe Hesabı'nda Vade Tarihi etkinse",
    "Si Cuenta Contable tiene habilitada el Area. Ver T.G. 26": "Muhasebe Hesabı'nda Alan etkinse. Bkz. T.G. 26",
    "Si Cuenta Contable tiene seleccionado Tipo de Anexo Referencia": "Muhasebe Hesabı'nda Referans Ek Türü seçiliyse",
    "Si Cuenta Contable tiene habilitado Tipo Medio Pago. Ver T.G. 'S1'": "Muhasebe Hesabı'nda Ödeme Yöntemi Türü etkinse. Bkz. T.G. 'S1'",
    "Si Tipo de Documento es 'NA' ó 'ND' Ver T.G. 06": "Belge Türü 'NA' veya 'ND' ise Bkz. T.G. 06",
    "Si Tipo de Documento es 'NC', NA' ó 'ND', incluye Serie y Número": "Belge Türü 'NC', 'NA' veya 'ND' ise, Seri ve Numarayı içerir",
    "Si Tipo de Documento es 'NC', NA' ó 'ND'": "Belge Türü 'NC', 'NA' veya 'ND' ise",
    "Si Tipo de Documento es 'NC', NA' ó 'ND'. Solo cuando el Tipo Documento de Referencia 'TK'": "Belge Türü 'NC', 'NA' veya 'ND' ise. Yalnızca Referans Belge Türü 'TK' olduğunda",
    "Si Tipo de Documento es 'NC', NA' ó 'ND'": "Belge Türü 'NC', 'NA' veya 'ND' ise",
    "Si Tipo de Documento es 'NC', NA' ó 'ND'": "Belge Türü 'NC', 'NA' veya 'ND' ise",
    "Si la Cuenta Contable tiene Habilitado Documento Referencia 2 y  Tipo de Documento es 'TK'": "Muhasebe Hesabı'nda Referans Belgesi 2 etkinse ve Belge Türü 'TK' ise",
    "Si la Cuenta Contable teien Habilitado Documento Referencia 2 y  Tipo de Documento es 'TK'": "Muhasebe Hesabı'nda Referans Belgesi 2 etkinse ve Belge Türü 'TK' ise",
    "Si la Cuenta Contable tiene Habilitado Documento Referencia 2. Cuando Tipo de Documento es 'TK', consignar la fecha de emision del ticket": "Muhasebe Hesabı'nda Referans Belgesi 2 etkinse. Belge Türü 'TK' olduğunda, kuponun düzenlenme tarihini belirtin",
    "Si la Cuenta Contable tiene configurada la Tasa:  Si es '1' ver T.G. 28 y '2' ver T.G. 29": "Muhasebe Hesabı'nda Oran yapılandırılmışsa: '1' ise Bkz. T.G. 28 ve '2' ise Bkz. T.G. 29",
    "Si la Cuenta Contable tiene conf. en Tasa:  Si es '1' ver T.G. 28 y '2' ver T.G. 29. Debe estar entre >=0 y <=999.99": "Muhasebe Hesabı'nda Oran yapılandırılmışsa: '1' ise Bkz. T.G. 28 ve '2' ise Bkz. T.G. 29. >=0 ve <=999.99 arasında olmalıdır",
    "Si la Cuenta Contable tiene configurada la Tasa. Debe ser el importe total del documento y estar entre >=0 y <=99999999999.99": "Muhasebe Hesabı'nda Oran yapılandırılmışsa. Belgenin toplam tutarı olmalı ve >=0 ile <=99999999999.99 arasında olmalıdır",
    "Si la Cuenta Contable tiene configurada la Tasa. Debe ser el importe total del documento y estar entre >=0 y <=99999999999.99": "Muhasebe Hesabı'nda Oran yapılandırılmışsa. Belgenin toplam tutarı olmalı ve >=0 ile <=99999999999.99 arasında olmalıdır",
    "Especificar solo si Tipo Conversión es 'F'. Se permite 'M' Compra y 'V' Venta.": "Yalnızca Dönüşüm Türü 'F' ise belirtin. 'M' Alış ve 'V' Satışa izin verilir.",
    "Especificar solo para comprobantes de compras con IGV sin derecho de crédito Fiscal. Se detalle solo en la cuenta 42xxxx": "Yalnızca Vergi kredisi hakkı olmayan KDV'li alım fişleri için belirtin. Yalnızca 42xxxx hesabında detaylandırılır",
    "Exportación Masiva": "Toplu Dışa Aktarma",
    "Cuenta de cancelación": "İptal hesabı",
    "Estado de Contingencia Retiro": "Çekim Acil Durum",
    "Estado de Contingencia Deposito": "Yatırım Acil Durum",
    "Estado Especial": "Özel Durum",
    "Proveedor de SMS": "SMS Sağlayıcısı",
    "Proveedor de Email": "E-posta Sağlayıcısı",
    "Cerrar día especifico": "Belirli bir günü kapat",
    "Descripción del reporte: Flujo Caja Resumido": "Rapor açıklaması: Özet Nakit Akışı",
    "Fecha creación del reporte:": "Rapor oluşturma tarihi:",
    "Serie": "Seri",
    "QR Copiado!": "QR Kopyalandı!",
    "Enviar código al celular": "Kodu cep telefonuna gönder",
    "Código enviado": "Kod gönderildi",
    "¿Producto tiene cupo?": "Ürünün kotası var mı?",
    "Productos terceros con cupo": "Kotalı üçüncü taraf ürünleri",
    "Agregar cupo": "Kota ekle",
    "Cupo Agregado": "Kota eklendi",
    "Ingreso editado satisfactoriamente": "Gelir başarıyla düzenlendi",
    "Editar Ingreso": "Geliri Düzenle",
    "Editar Egreso": "Gideri Düzenle",
    "Egreso editado satisfactoriamente": "Gider başarıyla düzenlendi",
    "Ingreso por tarjeta de crédito editado satisfactoriamente": "Kredi kartı geliri başarıyla düzenlendi",
    "Identificador": "Tanımlayıcı",
    "Enviar banner invasivo": "İstilacı banner gönder",
    "Banner invasivo enviado satisfactoriamente": "İstilacı banner başarıyla gönderildi",
    "URL Imagen": "Resim URL'si",
    "URL Redirección": "Yönlendirme URL'si",
    "Contenido": "İçerik",
    "Texto del boton": "Düğme metni",
    "Usuarios Id": "Kullanıcı Id",
    "Fecha envío": "Gönderim tarihi",
    "Fecha expiración": "Son kullanma tarihi",
    "Enviar popup": "Popup gönder",
    "Título": "Başlık",
    "¿Es un juego?": "Bu bir oyun mu?",
    "URL Frame": "Çerçeve URL'si",
    "Popup enviado satisfactoriamente": "Popup başarıyla gönderildi",
    "Enviar franja": "Şerit gönder",
    "Franja enviada satisfactoriamente": "Şerit başarıyla gönderildi",
    "Saldo Asignado": "Atanan Bakiye",
    "Todas": "Tümü",
    "Expiradas": "Süresi Dolmuş",
    "Proveedor pagos de retiros": "Çekim ödemeleri sağlayıcısı",
    "Añadir Ingreso Producto Cupo": "Kota Ürünü Geliri Ekle",
    "Producto:": "Ürün:",
    "Cuenta Contable Cierre": "Kapanış Muhasebe Hesabı",
    "¿Somos agentes?": "Ajan mıyız?",
    "Máximo monto por retiro": "Çekim başına maksimum tutar",
    "Máximo monto pago premio": "Maksimum ödül ödeme tutarı",
    "Por fecha de retiro pagado": "Ödenen çekim tarihine göre",
    "Banner Invasivo": "İstilacı Banner",
    "Popup": "Popup",
    "Franja": "Şerit",
    "Fecha Caducidad Pago": "Ödeme Son Kullanma Tarihi",
    "Enviar banner invasivo": "İstilacı banner gönder",
    "Enviar popup": "Popup gönder",
    "Enviar franja": "Şerit gönder",
    "URL Imagen": "Resim URL'si",
    "URL Redirección": "Yönlendirme URL'si",
    "Contenido": "İçerik",
    "Texto del botón": "Düğme metni",
    "Usuarios Id": "Kullanıcı Id",
    "Fecha envío": "Gönderim tarihi",
    "Fecha expiración": "Son kullanma tarihi",
    "¿Es un juego?": "Bu bir oyun mu?",
    "Ir al usuario": "Kullanıcıya git",
    "Categorías sin agregar": "Eklenmemiş kategoriler",
    "Categorías Producto Partner": "İş Ortağı Ürün Kategorileri",
    "Explicación": "Açıklama",
    "Seleccione por lo menos un Partner": "En az bir İş Ortağı seçin",
    "Partners Seleccionados": "Seçili İş Ortakları",
    "Partners no Seleccionados": "Seçili Olmayan İş Ortakları",
    "Sub Proveedor": "Alt Sağlayıcı",
    "Franja Superior": "Üst Şerit",
    "Desea Eliminar Egreso?": "Gideri Silmek İstiyor musunuz?",
    "Eliminar Egreso": "Gideri Sil",
    "Egreso Eliminado": "Gider Silindi",
    "Desea Eliminar Ingreso?": "Geliri Silmek İstiyor musunuz?",
    "Eliminar Ingreso": "Geliri Sil",
    "Ingreso Eliminado": "Gelir Silindi",
    "Apuestas Canceladas": "İptal Edilen Bahisler",
    "Partner Referencia": "İş Ortağı Referansı",
    "Tipo de registro": "Kayıt türü",
    "Especifique tipo de registro si es corto o largo": "Kayıt türünü belirtin (kısa veya uzun)",
    "Corto": "Kısa",
    "Largo": "Uzun",
    "No Expiradas": "Süresi Dolmamış",
    "Plantillas": "Şablonlar",
    "Plantilla email guardada": "E-posta şablonu kaydedildi",
    "Plantilla sms guardada": "SMS şablonu kaydedildi",
    "Ninguno": "Hiçbiri",
    "Pagado fisicamente": "Fiziksel olarak ödendi",
    "Rechazar nota de retiro": "Para çekme notunu reddet",
    "Elija la forma de pago": "Ödeme şeklini seçin",
    "Pagar Nota": "Notu Öde",
    "Desea Pagar Nota de Retiro?": "Para Çekme Notunu Ödemek İstiyor musunuz?",
    "Nota de Retiro Rechazada": "Para Çekme Notu Reddedildi",
    "Nota de Retiro Aprobado": "Para Çekme Notu Onaylandı",
    "Reporte de billeteras": "Cüzdan raporu",
    "Desea Activar Billetera?": "Cüzdanı Etkinleştirmek İstiyor musunuz?",
    "Activar Billetera": "Cüzdanı Etkinleştir",
    "Billetera Activada": "Cüzdan Etkinleştirildi",
    "Desea Inactivar Billetera?": "Cüzdanı Devre Dışı Bırakmak İstiyor musunuz?",
    "Inactivar Billetera": "Cüzdanı Devre Dışı Bırak",
    "Billetera Inactivada": "Cüzdan Devre Dışı Bırakıldı",
    "Resumido": "Özet",
    "Configuración SEO": "SEO Yapılandırması",
    "Leido?": "Okundu mu?",
    "Información Extra": "Ek Bilgi",
    "Reporte de transacciones del saldo": "Bakiye işlemleri raporu",
    "Desea aprobar notas de retiro seleccionadas?": "Seçili para çekme notlarını onaylamak istiyor musunuz?",
    "Aprobar Notas": "Notları Onayla",
    "Notas de retiro aprobadas": "Para çekme notları onaylandı",
    "Seleccione por lo menos una nota de retiro para aprobar": "Onaylamak için en az bir para çekme notu seçin",
    "¿Es nuevo?": "Yeni mi?",
    "¿Esta seguro de realizar cambios en la configuración del SEO?": "SEO yapılandırmasında değişiklik yapmak istediğinizden emin misiniz?",
    "Añadir SEO": "SEO Ekle",
    "Idioma": "Dil",
    "PÁGINA:": "SAYFA:",
    "Historial de transferencias de saldo": "Bakiye transfer geçmişi",
    "Confirme retracción de": "Geri çekmeyi onayla",
    "Retraer": "Geri Çek",
    "Transferir a Usuario": "Kullanıcıya Transfer",
    "Retracción a Usuario": "Kullanıcıya Geri Çekme",
    "Valor Invalido": "Geçersiz Değer",
    "Activa o inactiva el tipo de saldo recargas": "Yükleme bakiye türünü etkinleştirir veya devre dışı bırakır",
    "Activa o inactiva el tipo de saldo retiros": "Çekim bakiye türünü etkinleştirir veya devre dışı bırakır",
    "Saldo bonos": "Bonus bakiyesi",
    "Activa o inactiva el tipo de saldo bonos": "Bonus bakiye türünü etkinleştirir veya devre dışı bırakır",
    "Saldo freebet": "Bedava bahis bakiyesi",
    "Activa o inactiva el tipo de saldo freebet": "Bedava bahis bakiye türünü etkinleştirir veya devre dışı bırakır",
    "Saldo freecasino": "Ücretsiz casino bakiyesi",
    "Activa o inactiva el tipo de saldo freecasino": "Ücretsiz casino bakiye türünü etkinleştirir veya devre dışı bırakır",
    "Retracción a Saldo Juego": "Oyun Bakiyesine Geri Çekme",
    "Retracción a Saldo Recargas": "Yükleme Bakiyesine Geri Çekme",
    "Sección": "Bölüm",
    "Id de transacción relacionada": "İlgili işlem Id",
    "Historial de transferencias de saldo realizadas": "Yapılan bakiye transfer geçmişi",
    "Historial de transferencias de saldo recibidas": "Alınan bakiye transfer geçmişi",
    "Transferir Saldo a": "Bakiye Transfer Et",
    "Consolidado nivel": "Konsolide seviye",
    "Historial de saldo agentes": "Ajan bakiye geçmişi",
    "Historial de saldo usuario administrativo": "Yönetici kullanıcı bakiye geçmişi",
    "Bonos casino": "Casino bonusları",
    "Bonos Virtuales": "Sanal Bonuslar",
    "Bonos Casino en vivo": "Canlı casino bonusları",
    "Fecha Cambio": "Değişiklik Tarihi",
    "Fecha Acción": "Eylem Tarihi",
    "Fecha Cierre": "Kapanış Tarihi",
    "Usuario Pagó": "Ödeyen Kullanıcı",
    "Impuesto Apuestas": "Bahis Vergisi",
    "Impuesto Apuesta": "Bahis Vergisi",
    "Impuesto Premios": "Ödül Vergisi",
    "Impuesto Premio": "Ödül Vergisi",
    "Con pasarelas de pago?": "Ödeme ağ geçitleriyle mi?",
    "Su sesión se ha perdido, acceda nuevamente.": "Oturumunuz sona erdi, lütfen tekrar giriş yapın.",
    "Aceptar": "Kabul Et",
    "Con apuestas anuladas?": "İptal edilen bahislerle mi?",
    "Con premios pendientes?": "Bekleyen ödüllerle mi?",
    "Esta nota de retiro no tiene permitido el pago por sistema": "Bu para çekme notu için sistem üzerinden ödeme izni yoktur",
    "Agregar Archivo": "Dosya Ekle",
    "Se ha realizado la Actualización satisfactoriamente.": "Güncelleme başarıyla gerçekleştirildi.",
    "Historial de saldo máquinas": "Makineler bakiye geçmişi",
    "Flujo Caja Resumido Máquina": "Makine Özet Nakit Akışı",
    "Máquina Productos": "Makine Ürünleri",
    "Máquina Proveedores": "Makine Sağlayıcıları",
    "Máquina Sub Proveedores": "Makine Alt Sağlayıcıları",
    "Máquina Tipo": "Makine Türü",
    "Máquina Referencia": "Makine Referansı",
    "Categoría Máquina Editado": "Makine Kategorisi Düzenlendi",
    "Producto Máquina Editado": "Makine Ürünü Düzenlendi",
    "Proveedor Máquina Editado": "Makine Sağlayıcısı Düzenlendi",
    "Sub Proveedor Máquina Editado": "Makine Alt Sağlayıcısı Düzenlendi",
    "Tipo producto Máquina Editado": "Makine Ürün Türü Düzenlendi",
    "Agrupado sólo por usuario afiliador": "Yalnızca ortak kullanıcıya göre gruplandırılmış",
    "Id Sistema": "Sistem Id",
    "Ver sólo por punto de venta": "Yalnızca satış noktasına göre görüntüle",
    "Proveedores internos": "Dahili sağlayıcılar",
    "Programa de lealtad": "Sadakat programı",
    "Puntos requeridos para el nivel 1": "Seviye 1 için gereken puanlar",
    "Puntos requeridos para el nivel 2": "Seviye 2 için gereken puanlar",
    "Puntos requeridos para el nivel 3": "Seviye 3 için gereken puanlar",
    "Puntos requeridos para el nivel 4": "Seviye 4 için gereken puanlar",
    "Puntos requeridos para el nivel 5": "Seviye 5 için gereken puanlar",
    "Puntos requeridos para el nivel 6": "Seviye 6 için gereken puanlar",
    "Puntos requeridos para el nivel 7": "Seviye 7 için gereken puanlar",
    "Puntos requeridos para el nivel 8": "Seviye 8 için gereken puanlar",
    "Puntos requeridos para el nivel 9": "Seviye 9 için gereken puanlar",
    "Puntos requeridos para el nivel 10": "Seviye 10 için gereken puanlar",
    "Monto depósito": "Para yatırma tutarı",
    "Monto (Dinero) requerido de los depósitos para obtener Z punto": "Z puanı kazanmak için gereken para yatırma tutarı (Para)",
    "Deportiva simple": "Tekli spor bahsi",
    "Monto (Dinero) requerido de una apuesta deportiva simple para obtener Z punto": "Z puanı kazanmak için gereken tekli spor bahsi tutarı (Para)",
    "Deportiva combinada de 2": "2'li kombine spor bahsi",
    "Monto (Dinero) requerido de una apuesta deportiva Combinada de 2 para obtener Z punto": "Z puanı kazanmak için gereken 2'li kombine spor bahsi tutarı (Para)",
    "Deportiva combinada de 3": "3'lü kombine spor bahsi",
    "Monto (Dinero) requerido de una apuesta deportiva Combinada de 3 para obtener Z punto": "Z puanı kazanmak için gereken 3'lü kombine spor bahsi tutarı (Para)",
    "Deportiva combinada de 4": "4'lü kombine spor bahsi",
    "Monto (Dinero) requerido de una apuesta deportiva Combinada de 4 para obtener Z punto": "Z puanı kazanmak için gereken 4'lü kombine spor bahsi tutarı (Para)",
    "Deportiva combinada de 5": "5'li kombine spor bahsi",
    "Monto (Dinero) requerido de una apuesta deportiva Combinada de 5 para obtener Z punto": "Z puanı kazanmak için gereken 5'li kombine spor bahsi tutarı (Para)",
    "Deportiva combinada de 6": "6'lı kombine spor bahsi",
    "Monto (Dinero) requerido de una apuesta deportiva Combinada de 6 para obtener Z punto": "Z puanı kazanmak için gereken 6'lı kombine spor bahsi tutarı (Para)",
    "Deportiva combinada de 7": "7'li kombine spor bahsi",
    "Monto (Dinero) requerido de una apuesta deportiva Combinada de 7 para obtener Z punto": "Z puanı kazanmak için gereken 7'li kombine spor bahsi tutarı (Para)",
    "Deportiva combinada de 8": "8'li kombine spor bahsi",
    "Monto (Dinero) requerido de una apuesta deportiva Combinada de 8 para obtener Z punto": "Z puanı kazanmak için gereken 8'li kombine spor bahsi tutarı (Para)",
    "Deportiva combinada de 9": "9'lu kombine spor bahsi",
    "Monto (Dinero) requerido de una apuesta deportiva Combinada de 9 para obtener Z punto": "Z puanı kazanmak için gereken 9'lu kombine spor bahsi tutarı (Para)",
    "Deportiva combinada de 10": "10'lu kombine spor bahsi",
    "Monto (Dinero) requerido de una apuesta deportiva Combinada de 10 para obtener Z punto": "Z puanı kazanmak için gereken 10'lu kombine spor bahsi tutarı (Para)",
    "Premios deportivos": "Spor ödülleri",
    "Monto (Dinero) requerido de premios deportivos para obtener Z punto": "Z puanı kazanmak için gereken spor ödülleri tutarı (Para)",
    "Apuestas de casino": "Casino bahisleri",
    "Monto (Dinero) requerido de apuestas de casino para obtener Z punto": "Z puanı kazanmak için gereken casino bahisleri tutarı (Para)",
    "Premios de casino": "Casino ödülleri",
    "Monto (Dinero) requerido de premios de casino para obtener Z punto": "Z puanı kazanmak için gereken casino ödülleri tutarı (Para)",
    "Monto requerido de retiros": "Gereken çekim tutarı",
    "Monto (Dinero) requerido de retiros para obtener Z punto": "Z puanı kazanmak için gereken çekim tutarı (Para)",
    "Puntos Base": "Temel Puanlar",
    "Especifique el numero de puntos que se tomara como base, equivalente a Z en los demás items.": "Diğer maddelerde Z'ye eşdeğer olarak temel alınacak puan sayısını belirtin.",
    "Tipos de movimientos": "Hareket türleri",
    "Puntos equivalentes por nivel": "Seviye başına eşdeğer puanlar",
    "IP de Cambio": "Değişiklik IP'si",
    "Ip Acción": "Eylem IP'si",
    "Puntos Lealtad": "Sadakat Puanları",
    "Observaciones": "Gözlemler",
    "Impuesto del GGR de la apuesta al momento de pagar": "Ödeme anında bahsin GGR'sinden alınan vergi",
    "Días de expiración de puntos": "Puanların son kullanma süresi (gün)",
    "Especifique el tiempo en días para la caducidad de los puntos": "Puanların sona ermesi için süreyi gün olarak belirtin",
    "Depositos:": "Para Yatırma:",
    "Apuestas en Deportivas:": "Spor Bahisleri:",
    "Apuestas en Casino:": "Casino Bahisleri:",
    "Total Apuestas:": "Toplam Bahisler:",
    "Premios en Deportivas:": "Spor Ödülleri:",
    "Premios en Casino:": "Casino Ödülleri:",
    "Total Premios:": "Toplam Ödüller:",
    "Notas pendientes:": "Bekleyen notlar:",
    "Valor Retirado:": "Çekilen Değer:",
    "Bonos:": "Bonuslar:",
    "Bonos Free Ganados:": "Kazanılan Ücretsiz Bonuslar:",
    "Ajustes Entrada:": "Giriş Düzeltmeleri:",
    "Ajustes Salida:": "Çıkış Düzeltmeleri:",
    "Total:": "Toplam:",
    "Desea realizar movimiento?": "Hareket yapmak istiyor musunuz?",
    "Reporte de Sesiones Casino": "Casino Oturum Raporu",
    "Máximo monto retiro por punto de venta": "Satış noktası başına maksimum çekim tutarı",
    "Especifique el monto máximo para retirar por punto de venta": "Satış noktası başına çekim için maksimum tutarı belirtin",
    "Saldo al Final": "Son Bakiye",
    "Valor de depósitos": "Para yatırma değeri",
    "Apuestas deportivas": "Spor bahisleri",
    "Premios deportivos": "Spor ödülleri",
    "Cancelaciones deportivas": "Spor iptalleri",
    "Apuestas de casino": "Casino bahisleri",
    "Premios de casino": "Casino ödülleri",
    "Cancelaciones de casino": "Casino iptalleri",
    "Retiros realizados": "Gerçekleştirilen çekimler",
    "Retiros cancelados": "İptal edilen çekimler",
    "Bonos redimidos": "Kullanılan bonuslar",
    "Encriptación": "Şifreleme",
    "Desea imprimir recibo?": "Fiş yazdırmak istiyor musunuz?",
    "Imprimir": "Yazdır",
    "Verificó domicilio": "Adres doğrulandı",
    "Link Afiliados:": "Ortak Linki:",
    "QR Afiliados:": "Ortak QR Kodu:",
    "Saldo:": "Bakiye:",
    "Billetera": "Cüzdan",
    "Comisión": "Komisyon",
    "Transferencias recibidas": "Alınan transferler",
    "Transferencias realizadas": "Yapılan transferler",
    "Reporte de Afiliados": "Ortak Raporu",
    "Recepcion de Efectivo": "Nakit Alımı",
    "ID Billetera": "Cüzdan ID",
    "Reporte de Billeteras": "Cüzdan Raporu",
    "Desea Inactivar Billetera?": "Cüzdanı Devre Dışı Bırakmak İstiyor musunuz?",
    "Billetera Inactivada": "Cüzdan Devre Dışı Bırakıldı",
    "Billeteras": "Cüzdanlar",
    "Cupones": "Kuponlar",
    "Desea enviar el cupón?": "Kuponu göndermek istiyor musunuz?",
    "Cupón Enviado Satisfactoriamente": "Kupon Başarıyla Gönderildi",
    "No tiene permitido el pago por sistema": "Sistem üzerinden ödeme izniniz yok",
    "Impuesto al pago de premio (GGR)": "Ödül ödemesi vergisi (GGR)",
    "Es Propio?": "Kendi Malı mı?",
    "Tipo de Punto": "Nokta Türü",
    "Físico": "Fiziksel",
    "(Nota: Por cada monto en XXX va a obtener Z puntos base)": "(Not: Her XXX tutarı için Z temel puan alacaksınız)",
    "Número de teléfono:": "Telefon numarası:",
    "Tipo de establecimiento": "Kuruluş türü",
    "Sportbook NGR Afiliados": "Ortaklar Spor Bahisleri NGR",
    "Sportbook GGR Punto venta IP": "Satış Noktası IP Spor Bahisleri GGR",
    "Sportbook GGR Punto venta": "Satış Noktası Spor Bahisleri GGR",
    "Deposito Punto venta": "Satış Noktası Para Yatırma",
    "Nro. de Agente:": "Ajan No:",
    "Nombre del agente:": "Ajan adı:",
    "Recargar Credito Agente": "Ajan Kredisi Yükle",
    "Solo Saldos Negativos": "Yalnızca Negatif Bakiyeler",
    "Contingencia Total": "Toplam Acil Durum",
    "Contingencia Deportivas": "Spor Acil Durum",
    "Contingencia Casino": "Casino Acil Durum",
    "Contingencia Casino en Vivo": "Canlı Casino Acil Durum",
    "Contingencia Virtuales": "Sanal Bahis Acil Durum",
    "Contingencia Poker": "Poker Acil Durum",
    "Contingencia Retiro": "Çekim Acil Durum",
    "Contingencia Depósito": "Yatırım Acil Durum",
    "Contingencia masiva": "Toplu acil durum",
    "Cargar archivo CSV": "CSV dosyası yükle",
    "Contingencia masiva creada": "Toplu acil durum oluşturuldu",
    "V. Entradas Recargas Agentes": "Ajan Yükleme Giriş D.",
    "Valor Entradas Recargas Agentes": "Ajan Yükleme Giriş Değeri",
    "Configuración Tabla": "Tablo Yapılandırması",
    "No tiene permitido esta acción": "Bu eyleme izniniz yok",
    "Añadir bono masivo": "Toplu bonus ekle",
    "Tipo Transferencia": "Transfer Türü",
    "Tipo Reporte": "Rapor Türü",
    "GGR. Deportivas": "Spor GGR.",
    "GGR. Casino": "Casino GGR.",
    "Tipoo": "Türr",
    "Sucursal bancaria": "Banka şubesi",
    "Tipo de ajuste": "Düzeltme türü",
    "Fraude": "Dolandırıcılık",
    "Traslado usuario inactivado": "Devre dışı bırakılan kullanıcı transferi",
    "Redondeo": "Yuvarlama",
    "Apuestas erróneas casino": "Hatalı casino bahisleri",
    "Pruebas": "Testler",
    "Otros": "Diğerleri",
    "Cedula de Ciudadania": "Vatandaşlık Kimliği",
    "Cedula de Extranjeria": "Yabancı Kimliği",
    "Recargas Anuladas": "İptal Edilen Yüklemeler",
    "Id punto de venta": "Satış noktası Id",
    "Nombre punto de venta": "Satış noktası adı",
    "Reportes personalizados": "Özelleştirilmiş raporlar",
    "Generado": "Oluşturuldu",
    "Cantidad Registros": "Kayıt Sayısı",
    "Solicitar Reporte": "Rapor İste",
    "Link Reporte": "Rapor Linki",
    "Reporte solicitado correctamente": "Rapor başarıyla istendi",
    "Buscar Permiso": "İzin Ara",
    "Desea rechazar notas de retiro seleccionadas?": "Seçili para çekme notlarını reddetmek istiyor musunuz?",
    "Rechazar Notas": "Notları Reddet",
    "Notas de retiro rechazadas": "Para çekme notları reddedildi",
    "Seleccione por lo menos una nota de retiro para rechazar": "Reddetmek için en az bir para çekme notu seçin",
    "Sitio": "Site",
    "Desea Anular Transferencia?": "Transferi İptal Etmek İstiyor musunuz?",
    "Anular Transferencia": "Transferi İptal Et",
    "Transferencia Anulada": "Transfer İptal Edildi",
    "Monto y confirmar monto no coinciden": "Tutar ve tutarı onayla eşleşmiyor",
    "Olvidó su contraseña?": "Şifrenizi mi unuttunuz?",
    "Se ha enviado correctamente el mensaje, te llegará un correo electrónico con la información.": "Mesaj başarıyla gönderildi, size bilgileri içeren bir e-posta gelecek.",
    "Email Inválido": "Geçersiz E-posta",
    "Mínimo 8 caracteres, una minúscula, una mayúscula y un número.": "Minimum 8 karakter, bir küçük harf, bir büyük harf ve bir rakam.",
    "Contraseña cambiada satisfactoriamente.": "Şifre başarıyla değiştirildi.",
    "Nueva contraseña y confirmar contraseña no coinciden.": "Yeni şifre ve şifreyi onayla eşleşmiyor.",
    "Nro. de Usuario:": "Kullanıcı No:",
    "Nombre del Usuario:": "Kullanıcı Adı:",
    "Reporte bonos redimidos": "Kullanılan bonuslar raporu",
    "Fecha Redimió": "Kullanım Tarihi",
    "ERROR10001 Existe transacción para el proveedor": "HATA10001 Sağlayıcı için işlem mevcut",
    "ERROR10002 Monto negativo": "HATA10002 Negatif tutar",
    "ERROR10003 Valor ticket diferente a rollback": "HATA10003 Kupon değeri geri almadan farklı",
    "ERROR10004 Debit con rollback antes": "HATA10004 Önceden geri alma ile borçlandırma",
    "ERROR10005 No existe la transacción": "HATA10005 İşlem mevcut değil",
    "ERROR10006 La transacción no es debit": "HATA10006 İşlem borçlandırma değil",
    "ERROR10007 Detalles de la trasacción no coinciden": "HATA10007 İşlem detayları eşleşmiyor",
    "ERROR10008 Valor de la transacción anterior diferente": "HATA10008 Önceki işlem değeri farklı",
    "ERROR10009": "HATA10009",
    "ERROR10010 Transaccion Juego Existe": "HATA10010 Oyun İşlemi Mevcut",
    "ERROR10011 Token vacío": "HATA10011 Token boş",
    "ERROR10012 Token ya existe": "HATA10012 Token zaten mevcut",
    "ERROR10013 UID vacío": "HATA10013 UID boş",
    "ERROR10014 # Debit diferente a # Credit": "HATA10014 # Borç # Alacaktan farklı",
    "ERROR10015 Trasacción con rollback": "HATA10015 Geri almalı işlem",
    "ERROR10016 Ronda cerrada": "HATA10016 Tur kapalı",
    "ERROR10017 Moneda Incorrecta": "HATA10017 Yanlış Para Birimi",
    "ERROR10018 Código de país incorrecto": "HATA10018 Yanlış ülke kodu",
    "ERROR10019": "HATA10019",
    "ERROR10020 Campo vacio": "HATA10020 Alan boş",
    "ERROR10021 UsuarioId vacío": "HATA10021 KullanıcıId boş",
    "ERROR10022": "HATA10022",
    "ERROR10023": "HATA10023",
    "ERROR10024": "HATA10024",
    "ERROR10025 Ticket ID ya existe": "HATA10025 Kupon ID zaten mevcut",
    "ERROR10026 Ticket ID no existe": "HATA10026 Kupon ID mevcut değil",
    "ERROR10030 Token Inactivo": "HATA10030 Pasif Token",
    "ERROR10031 BettypeID Ezugi incorrecto": "HATA10031 Yanlış Ezugi Bahis Türü ID",
    "ERROR10035 Usuario no tiene permiso para realizar esta acción": "HATA10035 Kullanıcının bu eylemi gerçekleştirme izni yok",
    "ERROR10027 El ticket ya esta cerrado": "HATA10027 Kupon zaten kapalı",
    "ERROR19000 La cédula ya existe": "HATA19000 Kimlik zaten mevcut",
    "ERROR19001 El login ya esta registrado": "HATA19001 Giriş adı zaten kayıtlı",
    "ERROR20000 Sesion del usuario expirada o invalida": "HATA20000 Kullanıcı oturumu süresi dolmuş veya geçersiz",
    "ERROR20001 Fondos insuficientes": "HATA20001 Yetersiz bakiye",
    "ERROR20002 SIGN incorrecto": "HATA20002 Yanlış İMZA",
    "ERROR20003 Usuario Inactivo": "HATA20003 Pasif Kullanıcı",
    "ERROR20004 Autoexclusion Casino Producto Interno": "HATA20004 Dahili Ürün Casino Kendi Kendini Men Etme",
    "ERROR20005 Autoexclusion Casino Categoria": "HATA20005 Kategori Casino Kendi Kendini Men Etme",
    "ERROR20006 Autoexclusion Casino SubCategoria": "HATA20006 Alt Kategori Casino Kendi Kendini Men Etme",
    "ERROR20007 Autoexclusion Casino Juego": "HATA20007 Oyun Casino Kendi Kendini Men Etme",
    "ERROR20008 Limite de deposito simple": "HATA20008 Tek para yatırma limiti",
    "ERROR20009 Limite de deposito diario": "HATA20009 Günlük para yatırma limiti",
    "ERROR20010 Limite de deposito semanal": "HATA20010 Haftalık para yatırma limiti",
    "ERROR20011 Limite de deposito mensual": "HATA20011 Aylık para yatırma limiti",
    "ERROR20012 Limite de deposito anual": "HATA20012 Yıllık para yatırma limiti",
    "ERROR20013 Limite de casino simple": "HATA20013 Tek casino limiti",
    "ERROR20014 Limite de casino diario": "HATA20014 Günlük casino limiti",
    "ERROR20015 Limite de casino semanal": "HATA20015 Haftalık casino limiti",
    "ERROR20016 Limite de casino mensual": "HATA20016 Aylık casino limiti",
    "ERROR20017 Limite de casino anual": "HATA20017 Yıllık casino limiti",
    "ERROR20018 Limite de casino en vivo simple": "HATA20018 Tek canlı casino limiti",
    "ERROR20019 Limite de casino en vivo diario": "HATA20019 Günlük canlı casino limiti",
    "ERROR20020 Limite de casino en vivo semanal": "HATA20020 Haftalık canlı casino limiti",
    "ERROR20021 Limite de casino en vivo mensual": "HATA20021 Aylık canlı casino limiti",
    "ERROR20022 Limite de casino en vivo anual": "HATA20022 Yıllık canlı casino limiti",
    "ERROR20023 Casino Inactivo": "HATA20023 Pasif Casino",
    "ERROR20024 Casino en Contingencia": "HATA20024 Casino Acil Durumda",
    "ERROR20025 LiveCasino Inactivo": "HATA20025 Pasif Canlı Casino",
    "ERROR20026 LiveCasino en Contingencia": "HATA20026 Canlı Casino Acil Durumda",
    "ERROR20027 Usuario autoexcluido total por tiempo": "HATA20027 Kullanıcı süreli olarak tamamen kendi kendini men etti",
    "ERROR20028 Usuario autoexcluido total": "HATA20028 Kullanıcı tamamen kendi kendini men etti",
    "ERROR20029 El usuario no esta registrado en la plataforma (Eliminado)": "HATA20029 Kullanıcı platformda kayıtlı değil (Silindi)",
    "ERROR21000 No se encuentra el numero de retiro": "HATA21000 Çekim numarası bulunamadı",
    "ERROR21001 El retiro ya fue procesado": "HATA21001 Çekim zaten işlendi",
    "ERROR21002 Valor menor al minimo permitido para retirar": "HATA21002 Çekim için izin verilen minimumdan daha düşük değer",
    "ERROR21003 Valor mayor al máximo permitido para retirar": "HATA21003 Çekim için izin verilen maksimumdan daha yüksek değer",
    "ERROR21004 La cuenta necesita estar verificada para poder retirar": "HATA21004 Çekim yapabilmek için hesabın doğrulanması gerekiyor",
    "ERROR21005 El registro debe de estar aprobado para poder retirar": "HATA21005 Çekim yapabilmek için kaydın onaylanması gerekiyor",
    "ERROR21006 La cuenta necesita estar verificada para poder depositar": "HATA21006 Para yatırabilmek için hesabın doğrulanması gerekiyor",
    "ERROR21007 El registro debe de estar aprobado para poder depositar": "HATA21007 Para yatırabilmek için kaydın onaylanması gerekiyor",
    "ERROR21008 Valor menor al minimo permitido para depositar": "HATA21008 Para yatırmak için izin verilen minimumdan daha düşük değer",
    "ERROR21009 Valor mayor al máximo permitido para depositar": "HATA21009 Para yatırmak için izin verilen maksimumdan daha yüksek değer",
    "ERROR21010 Producto no disponible": "HATA21010 Ürün mevcut değil",
    "ERROR21011 Tienes el máximo de notas de retiro permitidas activas": "HATA21011 İzin verilen maksimum aktif para çekme notuna sahipsiniz",
    "ERROR30001 Usuario Bloqueado por minima cantidad de logueos incorrectos": "HATA30001 Yanlış giriş denemesi sayısı aşıldığı için Kullanıcı Engellendi",
    "ERROR30002 Usuario (Login) no existe": "HATA30002 Kullanıcı (Giriş Adı) mevcut değil",
    "ERROR30003 Login con contraseña incorrectos": "HATA30003 Yanlış giriş adı veya şifre",
    "ERROR30004 En el momento nos encontramos en proceso de mantenimiento del sitio": "HATA30004 Şu anda site bakım sürecindeyiz",
    "ERROR30005 Usuario con registro inactivo": "HATA30005 Pasif kayıtlı kullanıcı",
    "ERROR30006 El usuario excede el número de cuentas bancarias registradas permitidas": "HATA30006 Kullanıcı izin verilen kayıtlı banka hesabı sayısını aşıyor",
    "ERROR30007 La clave ingresada es incorrecta": "HATA30007 Girilen şifre yanlış",
    "ERROR30008 El codigo de bono ingresado es incorrecto": "HATA30008 Girilen bonus kodu yanlış",
    "ERROR30009 Billetera no configurada -> QUISK": "HATA30009 Cüzdan yapılandırılmamış -> QUISK",
    "ERROR30010 No puede iniciar sesion en el sitio.": "HATA30010 Sitede oturum açamazsınız.",
    "ERROR30011 Usuario no coincide con token": "HATA30011 Kullanıcı token ile eşleşmiyor",
    "ERROR30012 Player Id was not found for the roundId": "HATA30012 Tur ID'si için Oyuncu ID'si bulunamadı",
    "ERROR30013 Game was not found for the roundId": "HATA30013 Tur ID'si için Oyun bulunamadı",
    "ERROR30014 UserId is different from the Wager UserId that needed to be cancelled": "HATA30014 Kullanıcı ID'si, iptal edilmesi gereken Bahis Kullanıcı ID'sinden farklı",
    "ERROR30015": "HATA30015",
    "ERROR30017 La ronda ya ha sido finalizada": "HATA30017 Tur zaten tamamlandı",
    "ERROR30018 La ronda ya ha sido cancelada": "HATA30018 Tur zaten iptal edildi",
    "ERROR30020": "HATA30020",
    "ERROR30021": "HATA30021",
    "ERROR50001": "HATA50001",
    "ERROR50002 Bono para lealtad no disponible": "HATA50002 Sadakat bonusu mevcut değil",
    "ERROR50030 La ronda ya ha sido finalizada": "HATA50030 Tur zaten tamamlandı",
    "ERROR60001": "HATA60001",
    "ERROR60002 Error en los datos enviados": "HATA60002 Gönderilen verilerde hata",
    "ERROR60003 La solicitud al mandante fue vacia": "HATA60003 Göndericiye yapılan talep boştu",
    "ERROR100000": "HATA100000",
    "ERROR100001 debitTransaction en Ezugi es vacio": "HATA100001 Ezugi'deki borçlandırmaİşlemi boş",
    "ERROR100002": "HATA100002",
    "ERROR100003 Rechazada por Automation": "HATA100003 Otomasyon tarafından reddedildi",
    "ERROR100004 Necesita aprobación por automation": "HATA100004 Otomasyon onayı gerekiyor",
    "ERROR100005 Usuario no pertenece al parnet": "HATA100005 Kullanıcı iş ortağına ait değil",
    "ERROR100010": "HATA100010",
    "ERROR100011": "HATA100011",
    "ERROR100012 Error General": "HATA100012 Genel Hata",
    "ERROR100013 Error en los parametros enviados": "HATA100013 Gönderilen parametrelerde hata",
    "ERROR100030 Punto de venta no tiene cupo disponible para realizar la recarga": "HATA100030 Satış noktasının yükleme yapmak için kullanılabilir kotası yok",
    "ERROR100086 El usuario tiene una verificación pendiente": "HATA100086 Kullanıcının bekleyen bir doğrulaması var",
    "ERROR110005 Este punto de venta no tiene autorizado hacer notas de retiro": "HATA110005 Bu satış noktasının para çekme notu yapma yetkisi yok",
    "ERROR110006 No es posible anular esta recarga por antigüedad": "HATA110006 Eskiliği nedeniyle bu yüklemeyi iptal etmek mümkün değil",
    "ERROR110007 Has alcanzado el máximo de cancelaciones de depósitos por día": "HATA110007 Günlük maksimum para yatırma iptali sayısına ulaştınız",
    "ERROR300152 Este usuario no puede usar puntos de venta o red aliadas, comuníquese con soporte": "HATA300152 Bu kullanıcı satış noktalarını veya bağlı ağları kullanamaz, destek ile iletişime geçin",
    "ERROR300155 ¡Atención! Para canjear tus puntos, primero debes verificar tu cuenta. Completa tu verificación y sigue disfrutando de tus beneficios": "HATA300155 Dikkat! Puanlarınızı kullanmak için önce hesabınızı doğrulamanız gerekir. Doğrulamanızı tamamlayın ve avantajlarınızdan yararlanmaya devam edin",
    "ERROR300167 Esta cuenta tiene una restricción activa. El usuario debe comunicarse con soporte para más información.": "HATA300167 Bu hesabın aktif bir kısıtlaması var. Kullanıcı daha fazla bilgi için destek ile iletişime geçmelidir.",
    "ERROR300180 Esta combinación ya ha sido registrada": "HATA300180 Bu kombinasyon zaten kaydedilmiş",
    "ERROR300181 La criptomoneda seleccionada está inactiva. No puede ser asociada": "HATA300181 Seçilen kripto para birimi pasif. İlişkilendirilemez",
    "ERROR300182 La red seleccionada está inactiva. Debe activarla para poder usarla": "HATA300182 Seçilen ağ pasif. Kullanabilmek için etkinleştirmeniz gerekir",
    "ERROR300172 Red asociada a una criptomoneda, el codigo de red no se puede cambiar": "HATA300172 Bir kripto para birimiyle ilişkili ağ, ağ kodu değiştirilemez",
    "ERROR300173 El código de red ingresado ya existe en el sistema": "HATA300173 Girilen ağ kodu sistemde zaten mevcut",
    "ERROR100035 Permiso Denegado": "HATA100035 İzin Reddedildi",
    "ERROR300023 Debe completar todos los campos requeridos": "HATA300023 Gerekli tüm alanları doldurmalısınız",
    "ERROR300176 Solo se permiten imágenes en formato PNG o JPG": "HATA300176 Yalnızca PNG veya JPG formatındaki resimlere izin verilir",
    "ERROR300177 Esta criptomoneda ya está registrada": "HATA300177 Bu kripto para birimi zaten kayıtlı",
    "ERROR300178 Dimensiones de imagen invalida": "HATA300178 Geçersiz resim boyutları",
    "ERROR300045 Este producto ya está asociado a esta combinación": "HATA300045 Bu ürün zaten bu kombinasyonla ilişkili",
    "ERROR300044 La combinación seleccionada está inactiva y no puede usarse": "HATA300044 Seçilen kombinasyon pasif ve kullanılamaz",
    "ERROR300092 Producto no disponible. No es posible realizar el pago de la solicitud de retiro.": "HATA300092 Ürün mevcut değil. Para çekme talebinin ödemesini gerçekleştirmek mümkün değil.",
    "Fecha de creación punto de venta": "Satış noktası oluşturma tarihi",
    "ProviderNameGroup": "SağlayıcıAdıGrubu",
    "Id": "Id",
    "Date": "Tarih",
    "Username": "Kullanıcı adı",
    "Game": "Oyun",
    "Identifier": "Tanımlayıcı",
    "ProviderName": "Sağlayıcı Adı",
    "Bets": "Bahisler",
    "TaxBet": "BahisVergisi",
    "Tax": "Vergi",
    "Stakes": "Bahisler",
    "FreeBalance": "Ücretsiz Bakiye",
    "Winnings": "Kazançlar",
    "Bonus": "Bonus",
    "Profit": "Kâr",
    "WinningsBonus": "KazançBonusu",
    "Profitness": "Kârlılık",
    "TransactionId": "İşlemId",
    "Type": "Tür",
    "Amount": "Tutar",
    "Name": "Ad",
    "IsActivate": "EtkinMi",
    "IsVerified": "DoğrulandıMı",
    "Abbreviated": "Kısaltılmış",
    "TypeDevice": "CihazTürü",
    "Image": "Resim",
    "ImageURL": "ResimURLsi",
    "ProviderId": "SağlayıcıId",
    "SubProviderId": "AltSağlayıcıId",
    "ExternalId": "HariciId",
    "Visible": "Görünür",
    "Provider": "Sağlayıcı",
    "Partner": "İş Ortağı",
    "FilterCountry": "ÜlkeFiltresi",
    "Maximum": "Maksimum",
    "Minimum": "Minimum",
    "Detail": "Detay",
    "SiteId": "SiteId",
    "Key": "Anahtar",
    "Url": "Url",
    "TypeIntegration": "EntegrasyonTürü",
    "Contingency": "Acil Durum",
    "Product": "Ürün",
    "Mobile": "Mobil",
    "Desktop": "Masaüstü",
    "ProcessingTime": "İşlemSüresi",
    "Order": "Sıra",
    "FeaturedOrder": "ÖneÇıkanSıra",
    "Rows": "Satırlar",
    "Columns": "Sütunlar",
    "New": "Yeni",
    "Description": "Açıklama",
    "Slug": "KısaAd",
    "Superior": "Üst",
    "Categorie": "Kategori",
    "Login": "Giriş",
    "FirstName": "Ad",
    "LastName": "Soyadı",
    "DocNumber": "BelgeNumarası",
    "DNI": "Kimlik",
    "Ip": "Ip",
    "MobilePhone": "CepTelefonu",
    "IsRegisterActivate": "KayıtEtkinMi",
    "CreatedLocalDate": "OluşturulanYerelTarih",
    "LastLoginLocalDate": "SonGirişYerelTarih",
    "CodePromotional": "PromosyonKodu",
    "IdCodePromotional": "PromosyonKoduId",
    "Site": "Site",
    "ClientId": "MüşteriId",
    "CreatedLocal": "YerelOluşturuldu",
    "PaymentSystemName": "ÖdemeSistemiAdı",
    "TypeName": "TürAdı",
    "CurrencyId": "ParaBirimiId",
    "Commission": "Komisyon",
    "ModifiedLocal": "YerelDeğiştirildi",
    "State": "Durum",
    "CashDeskId": "KasaId",
    "UserId": "KullanıcıId",
    "BetShopName": "BahisOfisiAdı",
    "PaymentDate": "ÖdemeTarihi",
    "ByAllowDate": "İzinTarihineGöre",
    "UserModifId": "DeğiştirenKullanıcıId",
    "PlayerId": "OyuncuId",
    "UserName": "KullanıcıAdı",
    "Category": "Kategori",
    "SubCategory": "AltKategori",
    "FinalDate": "BitişTarihi",
    "Reason": "Neden",
    "AutoAmount": "OtomatikTutar",
    "UserCreation": "OluşturanKullanıcı",
    "UserModified": "DeğiştirenKullanıcı",
    "OtherBonus": "DiğerBonus",
    "TaxPayout": "ÖdemeVergisi",
    "Code": "Kod",
    "CreateLocalDate": "YerelOluşturmaTarihi",
    "Currency": "ParaBirimi",
    "AmountDeposit": "ParaYatırmaTutarı",
    "AmountWithdraw": "ParaÇekmeTutarı",
    "PartnerBonusId": "İşOrtağıBonusId",
    "PartnerBonusName": "İşOrtağıBonusAdı",
    "AcceptanceDateLocal": "YerelKabulTarihi",
    "BonusType": "BonusTürü",
    "AmountConverted": "DönüştürülenTutar",
    "RolloverRequired": "GerekliÇevrim",
    "RolloverWagered": "ÇevrilenMiktar",
    "RolloverRemaining": "KalanÇevrim",
    "ClientBonusExpirationDateLocal": "MüşteriBonusBitişTarihiYerel",
    "Fecha": "Tarih",
    "Moneda": "ParaBirimi",
    "CantidadTickets": "KuponSayısı",
    "ValorEntradasEfectivo": "NakitGirişDeğeri",
    "ValorEntradasBonoTC": "BonusKKGirişDeğeri",
    "ValorEntradasTraslados": "TransferGirişDeğeri",
    "ValorEntradasRecargas": "YüklemeGirişDeğeri",
    "ValorSalidasEfectivo": "NakitÇıkışDeğeri",
    "ValorSalidasTraslados": "TransferÇıkışDeğeri",
    "ValorSalidasNotasRetiro": "ParaÇekmeNotlarıÇıkışDeğeri",
    "Saldo": "Bakiye",
    "VoidedPlacedBets": "İptalEdilenYapılanBahisler",
    "ValorEntradasEfectivoNeto": "NetNakitGirişDeğeri",
    "RecargasAnuladas": "İptalEdilenYüklemeler",
    "VoidedPaidBets": "İptalEdilenÖdenenBahisler",
    "ValorSalidasEfectivoNeto": "NetNakitÇıkışDeğeri",
    "Stake": "BahisTutarı",
    "StakePromedio": "OrtalamaBahisTutarı",
    "Payout": "Ödeme",
    "Bonos": "Bonuslar",
    "Ggr": "GGR",
    "GgrPorc": "GGRYüzdesi",
    "UsersRegistered": "KayıtlıKullanıcılar",
    "FirstDeposits": "İlkParaYatırmalar",
    "TypeBet": "BahisTürü",
    "BetShop": "BahisOfisi",
    "DatePayment": "ÖdemeTarihi",
    "BetShopPayment": "BahisOfisiÖdemesi",
    "Cashier": "Kasiyer",
    "ClosingDate": "KapanışTarihi",
    "WinningAmount": "KazanılanTutar",
    "WinningAmountTotal": "ToplamKazanılanTutar",
    "Odds": "Oranlar",
    "UserIP": "KullanıcıIP",
    "Wallet": "Cüzdan",
    "TicketId": "KuponId",
    "CantidadTicketsCasino": "CasinoKuponSayısı",
    "CantidadTicketsCasinoVivo": "CanlıCasinoKuponSayısı",
    "TotalTickets": "ToplamKupon",
    "AmountDeposits": "ParaYatırmaTutarı",
    "AmountWinnings": "KazançTutarı",
    "Deposits": "ParaYatırma",
    "WithdrawPending": "BekleyenÇekim",
    "Paid": "Ödendi",
    "StakeCasino": "CasinoBahisTutarı",
    "StakeLiveCasino": "CanlıCasinoBahisTutarı",
    "TotalStake": "ToplamBahisTutarı",
    "PayoutCasino": "CasinoÖdemesi",
    "PayoutLiveCasino": "CanlıCasinoÖdemesi",
    "TotalPayout": "ToplamÖdeme",
    "Ticket": "Kupon",
    "UserPartner": "İşOrtağıKullanıcısı",
    "UserAggregator": "ToplayıcıKullanıcısı",
    "CreationDate": "OluşturmaTarihi",
    "ValueBet": "BahisDeğeri",
    "ValuePrize": "ÖdülDeğeri",
    "TypeBalance": "BakiyeTürü",
    "UserCreated": "OluşturanKullanıcı",
    "BeforeAdjust": "DüzeltmeÖncesi",
    "AfterAdjust": "DüzeltmeSonrası",
    "Ticked Id": "Kupon Id",
    "Value": "Değer",
    "Movement": "Hareket",
    "BalanceDeposit": "YatırımBakiyesi",
    "BalanceWithdrawal": "ÇekimBakiyesi",
    "Country": "Ülke",
    "BalanceInitial": "BaşlangıçBakiyesi",
    "AmountBets": "BahisTutarı",
    "AmountWin": "KazançTutarı",
    "GgrAmountWin": "GGRKazançTutarı",
    "AmountBetsCasino": "CasinoBahisTutarı",
    "AmountWinCasino": "CasinoKazançTutarı",
    "GgrAmountWinCasino": "GGRCasinoKazançTutarı",
    "WithdrawCreates": "OluşturulanÇekimler",
    "WithdrawDeletes": "SilinenÇekimler",
    "AdjustmentE": "GirişDüzeltmesi",
    "AdjustmentS": "ÇıkışDüzeltmesi",
    "BonusCasino": "CasinoBonusu",
    "BonusVirtual": "SanalBonus",
    "BonusCasinoLive": "CanlıCasinoBonusu",
    "BalanceEnd": "SonBakiye",
    "BalanceEndCalc": "HesaplananSonBakiye",
    "BalanceGap": "BakiyeFarkı",
    "WithdrawPaid": "ÖdenenÇekim",
    "WithdrawPend": "BekleyenÇekim",
    "BonusFreeWin": "ÜcretsizBonusKazancı",
    "DepositsUsersCount": "ParaYatıranKullanıcıSayısı",
    "DepositsCount": "ParaYatırmaSayısı",
    "InitialRechargeQuota": "BaşlangıçYüklemeKotası",
    "InitialGameQuota": "BaşlangıçOyunKotası",
    "EndGameQuota": "SonOyunKotası",
    "EndGameQuotaCalc": "HesaplananSonOyunKotası",
    "Route": "Rota",
    "Version": "Sürüm",
    "EncryptionValue": "ŞifrelemeDeğeri",
    "NameAffiliate": "OrtakAdı",
    "ClientRef": "MüşteriRef",
    "AmountBase": "TemelTutar",
    "AmountPaid": "ÖdenenTutar",
    "TypeQuota": "KotaTürü",
    "TypeTransaction": "İşlemTürü",
    "Assigned": "Atanan",
    "SessionId": "OturumId",
    "StartTime": "BaşlangıçZamanı",
    "EndTime": "BitişZamanı",
    "CreatedDate": "OluşturulmaTarihi",
    "AmountBetting": "BahisTutarı",
    "RegionName": "BölgeAdı",
    "DepartmentName": "DepartmanAdı",
    "CityName": "ŞehirAdı",
    "Phone": "Telefon",
    "Address": "Adres",
    "LastLoginDateLabel": "SonGirişTarihiEtiketi",
    "Email": "Eposta",
    "StateValidate": "DoğrulamaDurumu",
    "Action": "Eylem",
    "AgentBalance": "AjanBakiyesi",
    "SumAgentBalance": "ToplamAjanBakiyesi",
    "FinalId": "SonId",
    "WayPay": "ÖdemeYolu",
    "PaymentMethod": "ÖdemeYöntemi",
    "TypeAccount": "HesapTürü",
    "AccountBank": "BankaHesabı",
    "BranchBank": "BankaŞubesi",
    "CodeInterbank": "BankalararasıKod",
    "VerifdniAnt": "ÖncekiKimlikDoğrulama",
    "TypeDocument": "BelgeTürü",
    "Identification": "Kimlik",
    "ClientName": "MüşteriAdı",
    "Department": "Departman",
    "City": "Şehir",
    "ChangeDate": "DeğişiklikTarihi",
    "ChangeIp": "DeğişiklikIp",
    "ActionDate": "EylemTarihi",
    "ActionIp": "EylemIp",
    "SystemId": "SistemId",
    "Site Builderg": "Site Oluşturucu",
    "RiskStatus": "RiskDurumu",
    "LoyaltyLevel": "SadakatSeviyesi",
    "AccumulatedDepositsValue": "BirikmişParaYatırmaDeğeri",
    "AccumulatedWithdrawalsValue": "BirikmişParaÇekmeDeğeri",
    "AccumulatedAwardsValue": "BirikmişÖdülDeğeri",
    "AccumulatedGGRValue": "BirikmişGGRDeğeri",
    "AccumulatedBetsValue": "BirikmişBahisDeğeri",
    "ValueLastWithdrawal": "SonParaÇekmeDeğeri",
    "ValueLastDeposit": "SonParaYatırmaDeğeri",
    "DocExpirationDate": "BelgeSonKullanmaTarihi",
    "ValueLastWithdraw": "SonÇekimDeğeri",
    "PrematchAwards": "MaçÖncesiÖdüller",
    "LiveAwards": "CanlıÖdüller",
    "StakesBonus": "BonusBahisleri",
    "Reportes de Regulación": "Düzenleme Raporları",
    "Depositar": "Yatırmak",
    "Afiliados": "Ortaklar",
    "Ver QR": "QR'ye bakın",
    "Países": "Ülkeler",
    "Bancos": "Bankalar",
    "Menú productos": "Ürün menüsü",
    "Términos y condiciones": "Şartlar ve koşullar",
    "Política de privacidad": "Gizlilik Politikası",
    "Reporte de Loteria": "Piyango Raporu",
    "Reporte de Depósitos Punto de venta": "Satış Noktası Para Yatırma Raporu",
    "Estructura del Reporte para Juegos": "Oyunlar için Rapor Yapısı",
    "Informe Del Premio Mayor - Deportivas (8.7.6)": "Büyük Ödül Raporu - Spor (8.7.6)",
    "Informe Del Premio Mayor - Casino (3.7.4)": "Büyük Ödül Raporu - Casino (3.7.4)",
    "Informe Del Premio Mayor - Loteria (4.7.4)": "Büyük Ödül Raporu - Piyango (4.7.4)",
    "Informe Del Premio Mayor - Juegos (5.7.4)": "Büyük Ödül Raporu - Oyunlar (5.7.4)",
    "Informe Del Premio Mayor - Apuestas (6.7.4)": "Büyük Ödül Raporu - Bahisler (6.7.4)",
    "Reporte de Auditoria de Juegos": "Oyun Denetim Raporu",
    "Reporte de Auditoria de Loteria": "Piyango Denetim Raporu",
    "Reporte de Auditoria de Apuestas": "Bahis Denetim Raporu",
    "Reporte de Auditoria de Casino": "Casino Denetim Raporu",
    "Reporte de Auditoria de Casino en Vivo": "Canlı Casino Denetim Raporu",
    "Reporte de Auditoria de Juegos Virtuales": "Sanal Oyunlar Denetim Raporu",
    "Reporte de Auditoria de Juegos Promocionales": "Promosyon Oyunları Denetim Raporu",
    "Reporte de Auditoria de Juegos Especiales": "Özel Oyunlar Denetim Raporu",
    "Reporte de Auditoria de Juegos de Loteria": "Piyango Oyunları Denetim Raporu",
    "Reporte de Auditoria de Juegos de Bingo": "Bingo Oyunları Denetim Raporu",
    "Reporte de Auditoria de Juegos de Raspa y Gana": "Kazı Kazan Oyunları Denetim Raporu",
    "Reporte de Auditoria de Juegos de Casino en Vivo": "Canlı Casino Oyunları Denetim Raporu",
    "Reporte de Auditoria de Juegos de Casino": "Casino Oyunları Denetim Raporu",
    "Reporte de Auditoria de Juegos de Apuestas": "Bahis Oyunları Denetim Raporu",
    "Reporte de Auditoria de Juegos de Apuestas Deportivas": "Spor Bahis Oyunları Denetim Raporu",
    "Reporte de Auditoria de Juegos de Apuestas Hípicas": "At Yarışı Bahis Oyunları Denetim Raporu",
    "Reporte de Auditoria de Juegos de Apuestas Virtuales": "Sanal Bahis Oyunları Denetim Raporu",
    "Reporte de Auditoria de Juegos de Apuestas Especiales": "Özel Bahis Oyunları Denetim Raporu",
    "Reporte de Auditoria de Juegos de Apuestas Promocionales": "Promosyon Bahis Oyunları Denetim Raporu",
    "Reporte de Auditoria de Juegos de Apuestas de Loteria": "Piyango Bahis Oyunları Denetim Raporu",
    "Reporte de Auditoria de Juegos de Apuestas de Bingo": "Bingo Bahis Oyunları Denetim Raporu",
    "Reporte de Auditoria de Juegos de Apuestas de Raspa y Gana": "Kazı Kazan Bahis Oyunları Denetim Raporu",
    "Reporte de Auditoria de Juegos de Apuestas de Casino en Vivo": "Canlı Casino Bahis Oyunları Denetim Raporu",
    "Reporte de Auditoria de Juegos de Apuestas de Casino": "Casino Bahis Oyunları Denetim Raporu",
    "Reporte de Auditoria de Juegos de Apuestas Deportivas en Vivo": "Canlı Spor Bahis Oyunları Denetim Raporu",
    "Reporte de Auditoria de Juegos de Apuestas Hípicas en Vivo": "Canlı At Yarışı Bahis Oyunları Denetim Raporu",
    "Reporte de Auditoria de Juegos de Apuestas Virtuales en Vivo": "Canlı Sanal Bahis Oyunları Denetim Raporu",
    "Reporte de rendimiento del juego (3.7.2)": "Oyun performans raporu (3.7.2)",
    "Reporte de los ingresos consolidados del titular (Deportivas) (8.7.3)": "Hesap Sahibinin Konsolide Gelir Raporu (Spor) (8.7.3)",
    "Reportes de Pago del Premio Mayor (Sistemas Progresivos) (Deportivas) (8.7.6)": "Büyük Ödül Ödeme Raporları (Progresif Sistemler) (Spor) (8.7.6)",
    "Sub Proveedores": "Alt Sağlayıcılar",
    'Franquicias': 'Franchises',
    "Etiquetas": "Etiketler",
    "Reporte de Retiros Punto de Venta": "Satış Noktası Çekim Raporu",
    "Reporte de transacciones": "İşlem raporu",
    "Logs Generales": "Genel Kayıtlar",
    "Reporte de transferencias de saldo Recibidas": "Alınan bakiye transferi raporu",
    "Notas de usuario": "Kullanıcı notları",
    "Reporte de Landing": "Açılış Raporu",
    "Reporte de transferencias de saldo Realizadas": "Gerçekleştirilen bakiye transferi raporu",
    "Reporte de marketing": "Pazarlama raporu",
    "Pagar comisiones": "Komisyon ödemek",
    "Reporte de comisiones pagadas": "Ödenen komisyon raporu",
    "Nombre usuario": "Kullanıcı adı",
    "Pago de comisiones": "Komisyon ödemesi",
    "Tipo de comisión": "Komisyon türü",
    "Reporte de Poker": "Poker Raporu",
    "Subproveedor": "AltSağlayıcı",
    "ID de Usuario": "Kullanıcı ID'si",
    "ID de Casino Usuario": "Kullanıcı Casino ID'si",
    "ID de Sesión": "Oturum ID'si",
    "Valor Apostado Total": "Toplam Bahis Değeri",
    "Premio Total": "Toplam Ödül",
    "Inscripción a Torneos total": "Toplam Turnuva Kaydı",
    "Reporte de limitaciones": "Kısıtlama raporu",
    "Fecha y hora": "Tarih ve saat",
    "Fecha en que finaliza": "Bitiş tarihi",
    "Horas": "Saatler",
    "Observación": "Gözlem",
    "Productos terceros": "Üçüncü taraf ürünler",
    "Productos terceros Por Puntos de venta": "Satış Noktaları için Üçüncü Taraf Ürünler",
    "Tipos Centro Cargo": "Yük Merkezi Türleri",
    "Verificar Cuenta": "Hesabı Doğrula",
    "Verificación de usuario": "Kullanıcı doğrulaması",
    "Usuario Aprueba": "Kullanıcı Onaylıyor",
    "Nota": "Not",
    "Aprobación Logs Puntos": "Satış Noktası Onay Kayıtları",
    "Menú Padre": "Ana Menü",
    "Contigencias Totales": "Toplam Acil Durumlar",
    "Restricción de usuarios": "Kullanıcı kısıtlaması",
    "Usuario creación": "Kullanıcı oluşturma",
    "Reporte ingresos consolidados del titular - Deportivas": "Hesap sahibinin konsolide gelir raporu - Spor",
    "Reportes de Regulacion": "Düzenleme Raporları",
    "Total de Apuesta": "Toplam Bahis",
    "Total de premios": "Toplam ödüller",
    "Total de bonificaciones": "Toplam bonuslar",
    "Total de premios del sistema progresivo": "Progresif sistemin toplam ödülleri",
    "Total de devoluciones": "Toplam iadeler",
    "Total de comisiones por servicio": "Toplam hizmet komisyonları",
    "Total de impuestos": "Toplam vergiler",
    "Total GGR": "Toplam GGR",
    "Derechos de inscripción": "Kayıt ücretleri",
    "ID Jugador": "Oyuncu ID'si",
    "Nombre del jugador": "Oyuncu adı",
    "Nombre del Juego": "Oyunun Adı",
    "Tipo de Juego": "Oyun Türü",
    "ID Apuesta": "Bahis ID'si",
    "Fecha de la transacción": "İşlem tarihi",
    "Tipo de transacción": "İşlem türü",
    "Informe del Premio Mayor - Deportivas (-.-.-)": "Büyük Ödül Raporu - Spor (-.-.-)",
    "Informe del premio mayor - Casino (-.-.-)": "Büyük Ödül Raporu - Casino (-.-.-)",
    "Informe del premio mayor - Loteria (-.-.-)": "Büyük Ödül Raporu - Piyango (-.-.-)",
    "Reporte de rendimiento del juego": "Oyun performans raporu",
    "Reportes Pago del Premio Mayor - Deportivas": "Büyük Ödül Ödemesi Raporları - Spor",
    "Id del Jackpot": "Jackpot Id'si",
    "Identificación del jugador ganador": "Kazanan oyuncunun kimliği",
    "Número de documento": "Belge numarası",
    "Tipo de documento": "Belge türü",
    "Liga o evento deportivo": "Lig veya spor etkinliği",
    "Monto total ganado": "Toplam kazanılan miktar",
    "Modalidad del sistema progresivo": "Progresif sistem modu",
    "Fecha y hora del pago": "Ödeme tarihi ve saati",
    "Monto inicial del sistema progresivo": "Progresif sistemin başlangıç tutarı",
    "Fecha de inicio del sistema progresivo": "Progresif sistemin başlangıç tarihi",
    "Nombre del juego": "Oyunun adı",
    "% Retorno real": "% Gerçek Getiri",
    "Total Apuesta": "Toplam Bahis",
    "Total apuestas por bonificación": "Bonus bahislerinin toplamı",
    "Total de premios por bonificación": "Bonus ödüllerinin toplamı",
    "Total de apuestas anuladas": "İptal edilen bahislerin toplamı",
    "Imagen cuadrada": "Kare görüntü",
    "SubProveedor": "AltSağlayıcı",
    "ID Externo 2": "Harici ID 2",
    "Productos Masivo": "Toplu Ürünler",
    "Añadir Franquicia": "Franchise Ekle",
    "Banco Id": "Banka Id",
    "Añadir Banco": "Banka Ekle",
    "Iniciar sesión": "Oturum aç",
    "Ventas": "Satışlar",
    "Rollback": "Geri Alma",
    "Apuestas Antiguas": "Eski Bahisler",
    "Filtrar por Nivel de Riesgo": "Risk Seviyesine Göre Filtrele",
    "Nivel de Lealtad": "Sadakat Seviyesi",
    "Saldo Masivo": "Toplu Bakiye",
    "Usuarios Masivo": "Toplu Kullanıcılar",
    "Categorización": "Kategorilendirme",
    "Desactivar Contingencia": "Acil Durumu Devre Dışı Bırak",
    "Activar Contingencia": "Acil Durumu Etkinleştir",
    "userId": "kullanıcıId",
    "userName": "kullanıcıAdı",
    "rouletteId": "ruletId",
    "gameId": "oyunId",
    "rouletteName": "ruletAdı",
    'activationDate': 'etkinleştirmeTarihi',
    'redemptionDate': 'kurtarmaTarihi',
    "state": "durum",
    "awardPresented": "sunulanÖdül",
    "typeAward": "ödülTürü",
    "expirationDate": "sonKullanmaTarihi",
    "awardDescription": "ödülAçıklaması",
    "partner": "işOrtağı",
    "country": "ülke",
    "Reporte de depósitos Punto Venta": "Satış Noktası Para Yatırma Raporu",
    "Reporte de retiros": "Çekim Raporu",
    "Reporte de transacciones de apuestas": "Bahis İşlemleri Raporu",
    "Historico Saldos Agentes": "Ajan Bakiye Geçmişi",
    "Ajuste de Saldos Agentes": "Ajan Bakiye Ayarı",
    "Historico Saldos Administrativos": "Yönetim Bakiye Geçmişi",
    "Reporte de referidos": "Yönlendirme Raporu",
    "Pagar Comisiones": "Komisyon Öde",
    "Comisiones Pagadas": "Ödenen Komisyonlar",
    "Reporte de comisiones -": "Komisyon Raporu -",
    "Reporte de Casino -": "Casino Raporu -",
    "Reporte Referidos": "Yönlendirme Raporu",
    "ID Referente": "Yönlendiren ID'si",
    "ID Referido": "Yönlendirilen ID'si",
    "Fecha de Registro": "Kayıt Tarihi",
    "Fecha de Primer Deposito": "İlk Para Yatırma Tarihi",
    "Estado del Referido": "Yönlendirilenin Durumu",
    "Referidos Totales": "Toplam Yönlendirmeler",
    "Referidos Exitosos": "Başarılı Yönlendirmeler",
    "Bonos por Deposito": "Para Yatırma Bonusu",
    "Bonos por Apuesta": "Bahis Bonusu",
    "ID Usuario Plataforma": "Platform Kullanıcı ID'si",
    "Tipo de Comisión": "Komisyon Türü",
    "Tipo de juego": "Oyun Türü",
    "Tipo de Reporte": "Rapor Türü",
    "Detallado por sesión del usuario": "Kullanıcı oturumuna göre detaylı",
    "Resumido por jugador": "Oyuncuya göre özet",
    "Resumido por proveedor": "Sağlayıcıya göre özet",
    "Inscripción Torneo": "Turnuva Kaydı",
    "Cash": "Nakit",
    "Torneo": "Turnuva",
    "ID Limitación": "Kısıtlama ID'si",
    "Tipo de limitación": "Kısıtlama Türü",
    "Deportivas": "Spor",
    "Casino en vivo": "Canlı Casino",
    "Virtuales": "Sanal",
    "Impuesto Deposito": "Para Yatırma Vergisi",
    "Activa": "Etkin",
    "Pagado": "Ödendi",
    "Click para seleccionar ": "Seçmek için tıklayın",
    "CriptoAmount": "KriptoTutar",
    "Fecha inicio de la autoexclusión": "Otomatik dışlama başlangıç tarihi",
    "Fecha de modificación": "Değişiklik tarihi",
    "Fecha Modificó": "Değiştiren Tarih",
    "Apuestas Bonos": "Bonus Bahisleri",
    "RTP teórico": "Teorik RTP",
    "RTP Actual": "Gerçek RTP",
    "Suma Total Premio Jackpot": "Toplam Jackpot Ödülü",
    "Vertical": "Dikey",
    "Tipo de Campaña": "Kampanya Türü",
    "Detalle de la Campaña": "Kampanya Detayı",
    "Retención de Saldo": "Bakiye Tutma",
    "Reactivación": "Yeniden Etkinleştirme",
    "Retención": "Tutma",
    "Adquisición": "Edinme",
    "ID Concesionario": "Bayi ID'si",
    "Apuestas LIVE": "CANLI Bahisler",
    "Apuestas PREMATCH": "MAÇ ÖNCESİ Bahisler",
    "Apuestas Mixtas": "Karma Bahisler",
    "Apuestas HÍPICAS": "AT YARIŞI Bahisler",
    "Apuestas VIRTUALES": "SANAL Bahisler",
    "Retenciones premios deportivas": "Spor ödülleri tutmaları",
    "Premios LIVE": "CANLI Ödüller",
    "Premios PREMATCH": "MAÇ ÖNCESİ Ödüller",
    "Premios Mixtos": "Karma Ödüller",
    "Premios HÍPICAS": "AT YARIŞI Ödüller",
    "Premios VIRTUALES": "SANAL Ödüller",
    "Bonos proveedor": "Sağlayıcı Bonusu",
    "GGR LIVE": "GGR CANLI",
    "GGR PREMATCH": "GGR MAÇ ÖNCESİ",
    "GGR Mixtos": "GGR Karma",
    "GGR HÍPICAS": "GGR AT YARIŞI",
    "GGR VIRTUALES": "GGR SANAL",
    "Beneficiario Id": "Lehine Olan Id",
    "Fecha de pago": "Ödeme tarihi",
    "Pendiente por pagar Punto de venta": "Satış Noktası için Ödenmesi Beklenen",
    "Con Eliminadas?": "Silinenlerle mi?",
    "Usuario Aggregato": "Toplayıcı Kullanıcı",
    "Sumar Saldo": "Bakiye Ekle",
    "Restar Saldo": "Bakiyeyi Azalt",
    "Apuestas Casino": "Casino Bahisleri",
    "Nota de retiro Creada": "Oluşturulan Çekim Notu",
    "Nota de retiro Pagada": "Ödenen Çekim Notu",
    "Bono Redimido": "Kurtarılan Bonus",
    "Aumento de cupo": "Kota Artışı",
    "Salidas Gamificación": "Oyunlaştırma Çıkışları",
    "Entradas Gamificación": "Oyunlaştırma Girişleri",
    "Rollbacks de lotería": "Piyango geri alımları",
    "Venta Loterías": "Piyango Satışı",
    "Cantidad Depositos": "Para Yatırma Miktarı",
    "Usuarios Depositantes": "Para Yatıran Kullanıcılar",
    "Calc. Desfase": "Hesapla. Gecikme",
    "Premios Jackpot deportivas": "Spor Jackpot Ödülleri",
    "Premios Jackpot Casino": "Casino Jackpot Ödülleri",
    "Retenciones a las apuestas": "Bahislerden Tutmalar",
    "Impuesto Apuesta Casino": "Casino Bahis Vergisi",
    "Cupo Calc.": "Kota Hesaplama",
    "Cupo": "Kota",
    "Saldo Bruto Premios Virtuales": "Brüt Bakiye Sanal Ödüller",
    "Saldo Bruto Apuestas Virtuales": "Brüt Bakiye Sanal Bahisler",
    "Transf Recarga S": "Para Transferi S",
    "Transf Recarga E": "Para Transferi E",
    "Transf Apuesta S": "Bahis Transferi S",
    "Transf Apuesta E": "Bahis Transferi E",
    "Premios Virtuales": "Sanal Ödüller",
    "Pais": "Ülke",
    "Id Externo": "Harici Id",
    "Costo Plataforma": "Platform Maliyeti",
    "Razon": "Neden",
    "Valor despues": "Değer sonrası",
    "Valor antes": "Önceki Değer",
    "Elemento": "Öğe",
    "Información de banco": "Banka bilgisi",
    "Id transacción": "İşlem Id'si",
    "Administrativo": "Yönetim",
    "Punto de venta": "Satış Noktası",
    "Fecha de Verificación": "Doğrulama Tarihi",
    "Regalo": "Hediye",
    "ID User": "Kullanıcı ID'si",
    "Puntos": "Puanlar",
    "Puntos a expirar": "Sona erecek puanlar",
    "Puntos expirados": "Sona eren puanlar",
    "Puntos redimidos": "Kurtarılan puanlar",
    "Click Banner": "Banner'a Tıkla",
    "Links": "Bağlantılar",
    "Estado de Referido": "Yönlendirilenin Durumu",
    "Dinero Final": "Son Para",
    "Egresos Productos": "Ürün Giderleri",
    "Ingresos Productos": "Ürün Gelirleri",
    "Egresos Propios": "Kendi Giderleri",
    "Ingresos Pot Tarjetas de Credito": "Kredi Kartı Pot Gelirleri",
    "Ingresos Propios": "Kendi Gelirleri",
    "Dinero Inicial": "Başlangıç Parası",
    "Usuario Genera": "Oluşturan Kullanıcı",
    "Tipo de restricción": "Kısıtlama Türü",
    "Usuarios Sitebuilder": "Sitebuilder Kullanıcıları",
    "Verificación de usuarios": "Kullanıcı doğrulaması",
    "Aprobar Logs Puntos": "Satış Noktası Onay Kayıtları",
    "Demografía": "Demografi",
    "Contacto": "İletişim",
    "Identificación": "Kimlik",
    "Verificación": "Doğrulama",
    "Fecha de creacion": "Oluşturma tarihi",
    "Agregar Usuario": "Kullanıcı Ekle",
    "Agregar Usuarios Masivo": "Toplu Kullanıcı Ekle",
    "Crear Menú": "Menü Oluştur",
    "Crear Permiso": "İzin Oluştur",
    "Fecha creación": "Oluşturma tarihi",
    "Usuario modificó": "Kullanıcı tarafından değiştirildi",
    "Fecha modificó": "Değiştirilme tarihi",
    "Primer Nombre": "İlk Ad",
    "Nro Documento": "Belge Numarası",
    "Reclamaciones": "Şikayetler",
    "Formularios Genéricos": "Genel Formlar",
    "Cupones de Recarga": "Yükleme Kuponları",
    "Diligenciado": "Doldurulmuş",
    "Nombre Completo": "Tam Ad",
    "Cédula": "Kimlik",
    "ID Virtuales": "Sanal ID'ler",
    "Flujo Caja": "Nakit Akışı",
    "Recargar Agentes": "Ajanları Yükle",
    "Menú de mensajes": "Mesaj menüsü",
    "From Name": "Gönderen Adı",
    "To Name": "Alıcı Adı",
    "Lenguage": "Dil",
    "Prefijo celular": "Cep telefonu ön eki",
    "Código PATH": "PATH Kodu",
    "Número cédula": "Kimlik Numarası",
    "ID del usuario": "Kullanıcı ID'si",
    "Informes Tipo": "Rapor Türü",
    "Informacion Casino": "Casino Bilgisi",
    "Informacion Live Casino": "Canlı Casino Bilgisi",
    "Informacion Virtual": "Sanal Bilgi",
    "Informacion Hipica": "At Yarışı Bilgisi",
    "Menú de Apariencia": "Görünüm Menüsü",
    "Menú mesa de trabajo": "Çalışma Masası Menüsü",
    "Acuerdos": "Anlaşmalar",
    "Promocionales": "Promosyonlar",
    "Menú configuración": "Yapılandırma Menüsü",
    "Menú reportería": "Raporlama Menüsü",
    "Translation Manager": "Çeviri Yöneticisi",
    "QR Afiliados": "Ortaklar QR",
    "Link Copiado": "Kopyalanan Bağlantı",
    "Saldo: ": "Bakiye: ",
    "Cupo: ": "Kota: ",
    "Comisión: ": "Komisyon: ",
    "TRM Virtual Soft": "TRM Sanal Soft",
    "Moneda Origen": "Kaynak Para Birimi",
    "Moneda Destino": "Hedef Para Birimi",
    "Tasa de cambio (TRM)": "Döviz Kuru (TRM)",
    "Acciones": "Eylemler",
    "Crear TRM": "TRM Oluştur",
    "Sub Proveedor Id": "Alt Sağlayıcı Id",
    "SubProveedor Id": "AltSağlayıcı Id",
    "Franquicia Id": "Franchise Id",
    "Criptomoneda": "Kripto Para",
    "Tipo de Criptomoneda": "Kripto Para Türü",
    "Id Criptomoneda": "Kripto Para Id'si",
    "Nombre de Criptomoneda": "Kripto Para Adı",
    "Código ISO": "ISO Kodu",
    "Nueva Criptomoneda": "Yeni Kripto Para",
    "Criptomonedas Registradas": "Kayıtlı Kripto Paralar",
    "Criptomonedas": "Kripto Paralar",
    "Redes Blockchain": "Blockchain Ağları",
    "Asociación Cripto + Redes": "Kripto + Ağlar Birliği",
    "Redes Blockchain Registradas": "Kayıtlı Blockchain Ağları",
    "Nombre de Red": "Ağ Adı",
    "Nueva Red Blockchain": "Yeni Blockchain Ağı",
    "Id de Red": "Ağ Id'si",
    "Código de Red": "Ağ Kodu",
    "Red Blockchain": "Blockchain Ağı",
    "Asociar Cripto + Red": "Kripto + Ağı Birleştir",
    "URL API": "API URL'si",
    "Nivel de Riesgo": "Risk Seviyesi",
    "Fecha de Aceptacion PEP": "PEP Kabul Tarihi",
    "Estado de Contingencia Retiros": "Çekim Acil Durum Durumu",
    "Condición PEP": "PEP Koşulu",
    "Id Código Promocional": "Promosyon Kodu Id'si",
    "Celular verificado": "Doğrulanmış Cep Telefonu",
    "Reporte de eventos significativos y alteraciones - Deportivas": "Önemli olayların ve rahatsızlıkların bildirilmesi - Spor",
    "Reporte de eventos significativos y alteraciones (Deportivas) (8.7.5)": "Önemli Olaylar ve Değişiklikler Raporu (Spor) (8.7.5)",
    "Añadir Evento": "Etkinlik Ekle",
    "Identificación del evento": "Etkinlik Kimliği",
    "Usuario(s)": "Kullanıcı(lar)",
    "Motivo/descripción": "Neden/açıklama",
    "Valor antes de la alteración": "Değer önceki rahatsızlık",
    "Valor después de la alteración": "Değer sonraki rahatsızlık",
    "Reporte de las transacciones realizadas por cada jugador": "Her oyuncunun yaptığı işlemlerin raporu",
    "Reporte de las transacciones realizadas por cada jugador (Retiros)": "Her oyuncu tarafından gerçekleştirilen işlemlerin raporu (Çekimler)",
    "Numero del documento": "Belge numarası",
    "Identificador único del jugador": "Oyuncunun benzersiz tanımlayıcısı",
    "Numero de documento": "Belge numarası",
    "Fecha de solicitud": "Talep tarihi",
    "Fecha de resolución": "Çözüm tarihi",
    "Retiro": "Çekim",
    "Forma de retiro": "Çekim Şekli",
    "Estado de retiro": "Çekim Durumu",
    "Reporte transacciones realizadas por cada jugador Segundo Nivel": "Her oyuncu tarafından gerçekleştirilen işlemler raporu İkinci Seviye",
    "Cuota": "Kota",
    "Premio": "Ödül",
    "Selección": "Seçim",
    "Nombre del mercado": "Pazar Adı",
    "Nombre del evento": "Etkinlik Adı",
    "Nombre de la competencia": "Yarışma Adı",
    "Nombre del deporte": "Spor Adı",
    "Identificador único de la transacción": "İşlemin benzersiz tanımlayıcısı",
    "Reporte de la cuenta del jugador (Deportivas) (8.7.8)": "Oyuncu Hesabı Raporu (Spor) (8.7.8)",
    "Reporte de la cuenta del jugador - Deportivas": "Oyuncu Hesabı Raporu - Spor",
    "Fecha de términos y condiciones": "Şartlar ve Koşullar Tarihi",
    "Estado de la cuenta": "Hesap Durumu",
    "Fecha de inicio": "Başlangıç Tarihi",
    "Fecha de fin": "Bitiş Tarihi",
    "Motivo": "Neden",
    "Tipo de Exclusión/limitación": "Dışlama/kısıtlama Türü",
    "Reporte específico de la Plataforma (Deportivas) (8.7.9)": "Özel Platform Raporu (Spor) (8.7.9)",
    "Reporte específico de la plataforma - Deportivas": "Özel Platform Raporu - Spor",
    "Programa de juego/modalidad de juego": "Oyun programı/oyun modu",
    "Proveedor de servicios": "Hizmet Sağlayıcı",
    "Reporte de ingresos del Titular": "Hesap Sahibi Gelir Raporu",
    "Estado de la apuesta": "Bahis Durumu",
    "Cantidad de Selecciones": "Seçim Sayısı",
    "Fecha de ticket": "Bilet Tarihi",
    "Fecha de cálculo": "Hesaplama Tarihi",
    "Reporte de ingresos del titular": "Hesap Sahibi Gelir Raporu",
    "Reporte de eventos futuros (Deportivas) (8.7.4)": "Gelecek Olaylar Raporu (Spor) (8.7.4)",
    "Reporte de eventos futuros": "Gelecek Olaylar Raporu",
    "Apuesta abierta": "Açık Bahis",
    "Reporte transacciones realizadas por cada jugador (Deportivas) (8.7.7) Primer nivel": "Her oyuncu tarafından gerçekleştirilen işlemler raporu (Spor) (8.7.7) Birinci seviye",
    "Reporte transacciones realizadas por cada jugador Primer Nivel": "Her oyuncu tarafından gerçekleştirilen işlemler raporu Birinci Seviye",
    "Lugar de transacción": "İşlem Yeri",
    "Fecha de calculo": "Hesaplama Tarihi",
    "Reporte de las transacciones realizadas por cada jugador (3.7.6)": "Her oyuncu tarafından gerçekleştirilen işlemlerin raporu (3.7.6)",
    "Reporte transacciones realizadas por cada jugador Depositos": "Her oyuncu tarafından gerçekleştirilen işlemler raporu Para Yatırma",
    "Ajuste de saldo": "Bakiye Ayarı",
    "Créditos de bonificación": "Bonus Kredileri",
    "Estado de depósito": "Para Yatırma Durumu",
    "Medios de pago": "Ödeme Yöntemleri",
    "Depósito": "Para Yatırma",
    "Fecha de deposito": "Para Yatırma Tarihi",
    "Reporte de ingresos del titular (Segundo Nivel)": "Hesap Sahibi Gelir Raporu (İkinci Seviye)",
    "Reporte de ingresos del titular Segundo Nivel": "Hesap Sahibi Gelir Raporu İkinci Seviye",
    "Reporte de los ingresos consolidados del titular (3.7.3)": "Hesap Sahibinin Konsolide Gelir Raporu (3.7.3)",
    "Reporte de los ingresos consolidados del titular - Casino": "Hesap Sahibinin Konsolide Gelir Raporu - Casino",
    "Reporte de eventos significativos y alteraciones (3.7.5)": "Önemli Olaylar ve Değişiklikler Raporu (3.7.5)",
    "Reporte de eventos significativos y alteraciones - Casino": "Önemli Olaylar ve Değişiklikler Raporu - Casino",
    "Reportes de Pago del Premio Mayor (Sistemas Progesivos) (3.7.4)": "Büyük Ödül Ödeme Raporları (Progresif Sistemler) (3.7.4)",
    "Reportes de Pago del Premio Mayor - Casino": "Büyük Ödül Ödemesi Raporları - Casino",
    "Identificación única": "Benzersiz Kimlik",
    "Reporte de la cuenta del jugador - Casino": "Oyuncu Hesabı Raporu - Casino",
    "Reporte de la cuenta del jugador (3.7.7)": "Oyuncu Hesabı Raporu (3.7.7)",
    "Reporte específico de la Plataforma - Casino": "Özel Platform Raporu - Casino",
    "Reporte específico de la plataforma (3.7.8)": "Özel Platform Raporu (3.7.8)",
    "Código de registro de MINCETUR": "MINCETUR Kayıt Kodu",
    "Transferencias de saldo": "Bakiye Transferleri",
    "Retracción de saldo": "Bakiye Geri Çekme",
    "Balance": "Bakiye",
    "Recibir Publicidad": "Reklam Al",
    "ID de cuenta de jumio": "jumio hesap ID'si",
    "Link de registro": "Kayıt Bağlantısı",
    "Usuario de pruebas": "Test Kullanıcısı",
    "Proveedor de pruebas": "Test Sağlayıcısı",
    "NINGUNO": "HİÇBİR",
    "Historial de puntos": "Puan Geçmişi",
    "Puntos Final": "Son Puanlar",
    "Reporte de Referidos": "Yönlendirme Raporu",
    "Premios de Lealtad": "Sadakat Ödülleri",
    "Reporte Ruleta": "Rulet Raporu",
    "Fecha de Activación": "Etkinleştirme Tarihi",
    "Fecha de Redención": "Kurtarma Tarihi",
    "Fecha de Expiración": "Son Kullanma Tarihi",
    "Estado del Giro": "Dönüş Durumu",
    "Tipo de Premio": "Ödül Türü",
    "Nombre de Ruleta": "Rulet Adı",
    "ID Ruleta": "Rulet ID'si",
    "Nombre Ruleta": "Rulet Adı",
    "Fecha Activación": "Etkinleştirme Tarihi",
    "Fecha Redención": "Kurtarma Tarihi",
    "Premio Entregado": "Teslim Edilen Ödül",
    "Detalle Premio": "Ödül Detayı",
    "Nivel Requerido del Regalo": "Hediye için Gerekli Seviye",
    "Nivel del jugador": "Oyuncu Seviyesi",
    "Tipo Premio": "Ödül Türü",
    "Descripción Premio": "Ödül Açıklaması",
    "Id Usuario": "Kullanıcı Id",
    "Id Casino": "Casino Id",
    "Generar contraseña": "Parola oluştur",
    "Foto con documento": "Belge ile fotoğraf",
    "Enviar SMS": "SMS Gönder",
    "Enviar Email": "E-posta Gönder",
    "Enviar Celular": "Cep Telefonu Gönder",
    "Enviar Notificaciones": "Bildirim Gönder",
    "Abusador de Bonos": "Bonus Kötüye Kullanımı",
    "Verificó": "Doğruladı",
    'Tipo bloqueo': 'Engelleme türü',
    "Tipo de contingencia": "Acil Durum Türü",
    "Usuario Abusador de bonos": "Bonus Kötüye Kullanımı Kullanıcısı",
    "Jineteo": "At Yarışı Dolandırıcılığı",
    "Autoexclusion": "Otomatik Dışlama",
    "Contra cargos": "Karşı Yüklemeler",
    "Bajo revision": "İnceleme Altında",
    "General": "Genel",
    "Selecciona un periodo": "Bir dönem seçin",
    "Comentario": "Yorum",
    "Mes Inicial": "Başlangıç Ayı",
    "Mes Final": "Bitiş Ayı",
    "Flujo de caja resumido -": "Özet Nakit Akışı -",
    "Histórico de saldos punto de venta -": "Satış Noktası Bakiye Geçmişi -",
    "Histórico de Saldos -": "Bakiye Geçmişi -",
    "Informe Gerencial Agentes -": "Yöneticil Raporu Ajanlar -",
    "Informe Gerencial Usuarios -": "Yönetici Raporu Kullanıcılar -",
    "Informe Gerencial -": "Yönetici Raporu -",
    "Premios lealtad": "Sadakat Ödülleri",
    "Nivel requerido del regalo": "Hediye için Gerekli Seviye",
    "Id Regalo": "Hediye Id'si",
    "Forma Pago": "Ödeme Şekli",
    "ID Casino": "Casino ID'si",
    "Online": "Çevrimiçi",
    "Comprado": "Satın Alındı",
    "Entregado": "Teslim Edildi",
    "Partner Categorías": "Ortak Kategoriler",
    "Agregar": "Ekle",
    "Reporte de Emails": "E-posta Raporu",
    "ID Usuario Referente": "Yönlendiren Kullanıcı ID'si",
    "Fecha de envio": "Gönderim Tarihi",
    "ID Invitacion": "Davet ID'si",
    "Usuario existente": "Mevcut Kullanıcı",
    "Reportes de emails": "E-posta Raporları",
    "Reporte ajustes de puntos": "Puan Ayarları Raporu",
    "Reporte ajustes puntos": "Puan Ayarları Raporu",
    "Fecha de ajuste": "Ayarlama Tarihi",
    "ID Ajuste": "Ayarlama ID'si",
    "Tipo del movimiento": "Hareket Türü",
    "Tipo de movimiento": "Hareket Türü",
    "Id operador": "operatör Id'si",
    "Reporte de bonos redimidos": "Kurtarılan Bonus Raporu",
    "Reporte por condiciones - referidos": "Koşullara göre rapor - yönlendirmeler",
    "Id del referente": "Yönlendirenin Id'si",
    "Id del referido": "Yönlendirilenin Id'si",
    "Id del premio": "Ödül Id'si",
    "Mínimo primer depósito": "İlk Para Yatırma Asgari",
    "Mínimo valor en apuestas": "Bahislerde Asgari Değer",
    "Cuenta verificada": "Doğrulanmış Hesap",
    "Premio ID": "Ödül ID'si",
    "Bono elegido": "Seçilen Bonus",
    "Condición": "Koşul",
    "Valor objetivo": "Hedef Değer",
    "Valor actual": "Mevcut Değer",
    "Estado global": "Genel Durum",
    "Fecha expiración condición": "Koşul Son Kullanma Tarihi",
    "Fecha expiración Premio": "Ödül Son Kullanma Tarihi",
    "Fecha de cumplimiento": "Uyum Tarihi",
    "Reporte campaña promocionales": "Promosyon Kampanyası Raporu",
    "Deportivas-Reporte campaña promocionales": "Spor-Promosyon Kampanyası Raporu",
    "Reporte campañas promocionales": "Promosyon Kampanyası Raporu",
    "Tipo campaña:": "Kampanya Türü:",
    "Bono": "Bonus",
    "Turnuva": "Turnuva",
    "Sorteo": "Piyango",
    "ID Campaña": "Kampanya ID'si",
    "Id torneo": "Turnuva Id'si",
    "Ingresar": "Girmek",
    "Ingresar apuesta": "Bahis Gir",
    "Tipo de campaña": "Kampanya Türü",
    "Valor de la Apuesta": "Bahis Değeri",
    "Valor convertido en la Campaña": "Kampanyada dönüştürülen değer",
    "Casino-Reporte campaña promocionales": "Casino-Promosyon Kampanyası Raporu",
    "ID de la apuesta": "Bahis ID'si",
    "ID de la campaña": "Kampanya ID'si",
    "Premios Jackpot": "Jackpot Ödülleri",
    "Reporte de Premios jackpot": "Jackpot Ödül Raporu",
    "ID Jackpot": "Jackpot ID'si",
    "Fecha de caída": "Düşüş Tarihi",
    "Tipo de saldo": "Bakiye Türü",
    "Saldo Retiros": "Çekim Bakiyesi",
    "Verticales": "Dikeyler",
    "Numero de Apuesta": "Bahis Numarası",
    "Fecha Caída": "Düşüş Tarihi",
    "Reporte de impuestos de premios pagados": "Ödenen Ödül Vergi Raporu",
    "Impuestos sobre ganancias pagadas - Doradobet Guatemala": "Ödenen Kazanç Vergileri - Doradobet Guatemala",
    "Cantidad de depositos": "Para Yatırma Miktarı",
    "Valor depositado": "Yatırılan Değer",
    "Valor de depositos devueltos": "İade Edilen Para Yatırma Değeri",
    "Cantidad de retiros pagados": "Ödenen Çekim Miktarı",
    "Valor de retiros pagados": "Ödenen Çekim Değeri",
    "Base imponible": "Vergi matrahı",
    "Reporte de Pollas Deportivas": "Spor Toto Raporu",
    "Cuenta digital": "Dijital Hesap",
    "ID Final": "Nihai ID",
    "Fecha Modificado": "Değiştirilme Tarihi",
    "Direccion IP": "IP Adresi",
    "Aprobación Masiva": "Toplu Onay",
    "Rechazo masivo": "Toplu Reddetme",
    "Fecha de Eliminación": "Silme Tarihi",
    "ID Retiro": "Çekim ID'si",
    "Pago masivo": "Toplu Ödeme",
    "Sistem Id": "Sistem Id'si",
    "ID Gestor": "Yönetici ID'si",
    "Canal de pago": "Ödeme Kanalı",
    "Impuesto 2": "Vergi 2",
    "Valor final": "Nihai Değer",
    "External Id": "Harici Id",
    "TRM utilizada": "Kullanılan TRM",
    "Monto en cripto": "Kripto Tutarı",
    "Solicitud de retiro retail": "Perakende çekim talebi",
    "ID Partnert": "Ortak ID'si",
    "Crear mensaje": "Mesaj Oluştur",
    "Global Id": "Küresel Id",
    "Productos 2": "Ürünler 2",
    "Activacion Productos": "Ürün Etkinleştirme",
    "Habilitacion productos": "Ürün Etkinleştirme",
    "Productos no agregados": "Eklenmeyen Ürünler",
    "Productos Agregados": "Eklenen Ürünler",
    "API_PASSWORD": "API_ŞİFRE",
    "Proveedores no agregados": "Eklenmeyen Sağlayıcılar",
    "Proveedores Agregados": "Eklenen Sağlayıcılar",
    "Productos no habilitados": "Etkinleştirilmeyen Ürünler",
    "Productos habilitados": "Etkinleştirilen Ürünler",
    "Sub Proveedores no agregados": "Eklenmeyen Alt Sağlayıcılar",
    "Sub Proveedores Agregados": "Eklenen Alt Sağlayıcılar",
    "Partners Sub Proveedores": "Ortaklar Alt Sağlayıcılar",
    "Partners Sub Proveedores Orden": "Ortaklar Alt Sağlayıcılar Sıralama",
    "Credenciales Por Sub Proveedor": "Alt Sağlayıcı Başına Kimlik Bilgileri",
    "Partners Tipo": "Ortak Türü",
    "Tipo producto no agregados": "Eklenmeyen Ürün Türü",
    "Tipo producto Agregados": "Eklenen Ürün Türü",
    "Partners Categorías": "Ortak Kategoriler",
    "Ordenar Juegos": "Oyunları Sırala",
    "Banco Pais": "Banka Ülke",
    "Bancos no agregados": "Eklenmeyen Bankalar",
    "Bancos Agregados": "Eklenen Bankalar",
    "Direccion IP ": "IP Adresi ",
    "Numero": "Numara",
    "Tipo de red": "Ağ Türü",
    "Periodo": "Dönem",
    "Nombre completo del jugador": "Oyuncunun Tam Adı",
    "Zona": "Bölge",
    "Enviada": "Gönderildi",
    "Buscar From Name": "Gönderen Adı Ara",
    "Solicitudes de retiro retail": "Perakende çekim talepleri",
    "Rechazos masivo": "Toplu Reddetmeler",
    "Campo ID": "Alan ID'si",
    "Acciones ": "Eylemler ",
    "Tasa de cambio": "Döviz Kuru",
    "Guardar Cambios": "Değişiklikleri Kaydet",
    "¿Desea eliminar esta conversión de moneda?": "Bu para birimi dönüşümünü silmek istiyor musunuz?",
    "Confirmar": "Onayla",
    "Estable": "Kur",
    "Inestable": "Dengesiz",
    "Descripcion": "Açıklama",
    "Rejuego:": "Yeniden Oynama:",
    "Seguridad y Cambios": "Güvenlik ve Değişiklikler",
    "Día": "Gün",
    "Semana": "Hafta",
    "Mes (30 dias)": "Ay (30 gün)",
    "Indefinido": "Süresiz",
    "Rango personalizado": "Özel Aralık",
    "Live casino": "Canlı casino",
    "Limites": "Limitler",
    "Moneda Origen:": "Kaynak Para Birimi:",
    "Moneda Destino:": "Hedef Para Birimi:",
    "Tasa de cambio:": "Döviz Kuru:",
    "Editar TRM": "TRM'yi Düzenle",
    "Inactiva": "Etkin Değil",
    "Digita para seleccionar ": "Seçmek için yazın ",
    "Visualizacón Cripto + Red ": "Kripto + Ağ Görünümü ",
    "Visualizacón Cripto + Red": "Kripto + Ağ Görünümü",
    "Cerrar": "Kapat",
    "Añadir Etiqueta": "Etiket Ekle",
    "Abiertas": "Açık",
    "Cerradas": "Kapalı",
    "Confirmar Monto:": "Tutarı Onayla:",
    "Agregar conversión": "Dönüşüm ekle",
    "Referencia:": "Referans:",
    "Añadir Nota": "Not Ekle",
    "Desea Inactivar Sesión?": "Oturumu Kapatmak İstiyor musunuz?",
    "Reporte de puntos lealtad": "Sadakat Puanları Raporu",
    "Ajustar Puntos": "Puanları Ayarla",
    "Id Movimiento de marketing": "Pazarlama Hareketi Id'si",
    "Mi comisión": "Benim Komisyonum",
    "Por fecha de comisión pagado": "Ödenen Komisyon Tarihine Göre",
    "Visualización resumida": "Özet Görünüm",
    "Fecha modifico": "Değiştirilme tarihi",
    "Tipo de movimiento:": "Hareket Türü:",
    "Cantidad:": "Miktar:",
    "Ingreso": "Gelir",
    "Egreso": "Gider",
    "Aprobación de Usuarios": "Kullanıcı Onayı",
    "Ciudad ": "Şehir ",
    "Usuario backoffice": "Backoffice Kullanıcısı",
    "Cargar CSV": "CSV Yükle",
    "Crear Restricción": "Kısıtlama Oluştur",
    "Gestión Reclamaciones": "Şikayet Yönetimi",
    "Gestión Formularios Genericos": "Genel Form Yönetimi",
    "Año": "Yıl",
    "Cantidad ": "Miktar ",
    "El DNI anterior ya fue verificado.": "Önceki DNI zaten doğrulandı.",
    "El DNI posterior ya fue verificado.": "Sonraki DNI zaten doğrulandı.",
    "Las extensiones de archivo disponibles son: JPEG, JPG, PNG": "Mevcut dosya uzantıları şunlardır: JPEG, JPG, PNG",
    "Verificar cuenta": "Hesabı Doğrula",
    "Número de cuenta": "Hesap Numarası",
    "Agregar Cuenta": "Hesap Ekle",
    "Inactivar cuenta": "Hesabı Devre Dışı Bırak",
    "Retirar": "Çek",
    "Saldo a retirar:": "Çekilecek Bakiye:",
    "Pago Premio Lealtad": "Sadakat Ödülü Ödemesi",
    "Id premio": "Ödül Id'si",
    "Añadir Producto a Banco": "Ürünü Bankaya Ekle",
    "Productos a Banco": "Bankaya Ürünler",
    "Franquicias Productos": "Franchise Ürünleri",
    "Añadir Producto a Franquicia": "Ürünü Franchise'a Ekle",
    "Agregar Producto a Franquicia": "Ürünü Franchise'a Ekle",
    "Agregar Producto a Banco": "Ürünü Bankaya Ekle",
    "Añadir Sub Proveedor Partner": "Alt Sağlayıcı Ortağı Ekle",
    "Usuarios de Pruebas": "Test Kullanıcıları",
    "Editar Productos a Franquicias": "Franchise Ürünlerini Düzenle",
    "Países no agregados": "Toplu olmayan ülkeler",
    "Países Agregados": "Eklenen Ülkeler",
    "Activar Contingencia Masiva": "Toplu Acil Durumu Etkinleştir",
    "Desactivar Contingencia Masiva": "Toplu Acil Durumu Devre Dışı Bırak",
    "Añadir punto de venta:": "Satış Noktası Ekle:",
    "Programa de identificación de IP Activo": "Aktif IP Tanımlama Programı",
    "Subconcesionario2": "Alt Bayi2",
    "Entrega Premio Físico?": "Fiziksel Ödül Teslimi?",
    "Parte Superior Impresión recibo de pago de premio": "Üst Ödül Ödeme Makbuzu Baskısı",
    "Parte Inferior Impresión recibo de pago de premio": "Alt Ödül Ödeme Makbuzu Baskısı",
    "Parte Superior Impresión recibo de pago de retiro": "Üst Ödül Ödeme Makbuzu Baskısı",
    "Parte Inferior Impresión recibo de pago de retiro": "Alt Ödül Ödeme Makbuzu Baskısı",
    "Numero cédula": "Kimlik Numarası",
    "Historial cambios de cupo ": "Kota Değişiklik Geçmişi ",
    "Aprobar Depósitos Masivos": "Toplu Para Yatırma Onayı",
    "Alto": "Yüksek",
    "Medio": "Orta",
    "Bajo": "Düşük",
    "Reporte Virtuales": "Sanal Raporlar",
    "Reporte de hípica": "At Yarışı Raporu",
    "Añadir Subproveedor": "Alt Sağlayıcı Ekle",
    "Credenciales": "Kimlik Bilgileri",
    "Agregar Productos Masivos": "Toplu Ürün Ekleme",
    "Formulario de Registro de Criptomoneda": "Kripto Para Kayıt Formu",
    "Registro de Red Blockchain": "Blockchain Ağı Kaydı",
    "Formulario de Edición Cripto + Red": "Kripto + Ağ Düzenleme Formu",
    "Editar Etiqueta": "Etiketi Düzenle",
    "Usuario Id ": "Kullanıcı Id ",
    "Ticket Id ": "Bilet Id ",
    "Beneficiario Id ": "Lehine Olan Id ",
    "Editar Franquicia": "Franchise'ı Düzenle",
    "Agregar imagen cuadrada": "Kare Resim Ekle",
    "Editar Subproveedor": "Alt Sağlayıcıyı Düzenle",
    "Editar Banco": "Bankayı Düzenle",
    "Formulario de Edición de Criptomoneda": "Kripto Para Düzenleme Formu",
    "Subir Icono": "Simge Yükle",
    "Visualización de Criptomoneda": "Kripto Para Görünümü",
    "Nombre ": "Ad ",
    "Valor ": "Değer ",
    "Formulario de Asociación Cripto + Red": "Kripto + Ağ Birliği Formu",
    "Formulario de Asociación Cripto + Red ": "Kripto + Ağ Birliği Formu ",
    "Visualización Cripto + Red": "Kripto + Ağ Görünümü",
    "Visualización Cripto + Red ": "Kripto + Ağ Görünümü ",
    "Cédula de extranjería": "Yabancı Kimlik Kartı",
    "Cancelar ": "İptal ",
    "Guardar ": "Kaydet ",
    "Aprobaciones masivas": "Toplu Onaylar",
    "Aprobaciones masivas ": "Toplu Onaylar ",
    "Transferir Saldo a ": "Bakiyeyi Şuraya Transfer Et ",
    "Pagar por Sistema": "Sistem tarafından Öde",
    "Contingencia ": "Acil Durum ",
    "Contingencia Depósitos": "Acil Durum Para Yatırma",
    "Contingencia Depositos Retail": "Perakende Acil Durum Para Yatırma",
    "Contingencia Retail": "Perakende Acil Durum",
    "Contingencia Depósitos ": "Acil Durum Para Yatırma ",
    "Contingencia Depositos Retail ": "Perakende Acil Durum Para Yatırma ",
    "Contingencia Retail ": "Perakende Acil Durum ",
    "Enviar Notificaiones Push": "Push Bildirimleri Gönder",
    "Enviar Notificaiones Push ": "Push Bildirimleri Gönder ",
    "Verificó Celular": "Cep Telefonunu Doğruladı",
    "Verificó Celular ": "Cep Telefonunu Doğruladı ",
    "Ver historial de comentarios": "Yorum geçmişini gör",
    "Ver historial de comentarios ": "Yorum geçmişini gör ",
}

// FILE DOCUMENTED
